import React, { useState, useRef, useEffect } from "react";
import { createPortal } from "react-dom";
import styles from "./TopToolbar.module.css";
import { useThemedIcon } from "../../../hooks/useThemedIcon";
import {
  doc,
  updateDoc,
  getDoc,
  collection,
  query,
  where,
  orderBy,
  getDocs,
  deleteDoc,
} from "firebase/firestore";
import { db } from "../../../firebase/config";
import {
  updatePassword,
  reauthenticateWithCredential,
  EmailAuthProvider,
  signOut,
  verifyBeforeUpdateEmail,
} from "firebase/auth";
import pinActiveIconLight from "../../../assets/pin_active_light.svg";
import pinActiveIconDark from "../../../assets/pin_active_dark.svg";
import unpinIconLight from "../../../assets/unpin_light.svg";
import unpinIconDark from "../../../assets/unpin_dark.svg";
import noahLighter from "../../../assets/noah_lighter.svg";
import noahDarker from "../../../assets/noah_darker.svg";
import loadingIconLight from "../../../assets/loading_light.svg";
import loadingIconDark from "../../../assets/loading_dark.svg";
import featureIconLight from "../../../assets/feature_tree_active_light.svg";
import featureIconDark from "../../../assets/feature_tree_active_dark.svg";
import ellipsisIconLight from "../../../assets/ellipsis_active_light.svg";
import ellipsisIconDark from "../../../assets/ellipsis_active_dark.svg";
import ellipsisActiveIconLight from "../../../assets/ellipsis_active_light.svg";
import ellipsisActiveIconDark from "../../../assets/ellipsis_active_dark.svg";
import renameIconLight from "../../../assets/rename_light.svg";
import renameIconDark from "../../../assets/rename_dark.svg";
import deleteIconLight from "../../../assets/delete_light.svg";
import deleteIconDark from "../../../assets/delete_dark.svg";
import pinIconLight from "../../../assets/pin_light.svg";
import pinIconDark from "../../../assets/pin_dark.svg";
import sidebarIconActiveLight from "../../../assets/sidebar_active_light.svg";
import sidebarIconActiveDark from "../../../assets/sidebar_active_dark.svg";
import sidebarIconInactiveLight from "../../../assets/sidebar_non_active_light.svg";
import sidebarIconInactiveDark from "../../../assets/sidebar_non_active_dark.svg";
import { auth } from "../../../firebase/config";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { storage } from "../../../firebase/config";
// Import icons
// ADD THESE NEW IMPORTS:
import systemIconActiveLightTheme from "../../../assets/system_icon_active_light.svg";
import systemIconActiveDarkTheme from "../../../assets/system_icon_active_dark.svg";
import systemIconInactiveLightTheme from "../../../assets/system_icon_inactive_light.svg";
import systemIconInactiveDarkTheme from "../../../assets/system_icon_inactive_dark.svg";
import warningIconLight from "../../../assets/warning_light.svg";
import warningIconDark from "../../../assets/warning_dark.svg";
import visibleIconLight from "../../../assets/visible_light.svg";
import visibleIconDark from "../../../assets/visible_dark.svg";
import notVisibleIconLight from "../../../assets/not_visible_light.svg";
import notVisibleIconDark from "../../../assets/not_visible_dark.svg";
import appsIconLight from "../../../assets/search_active_light.svg";
import appsIconDark from "../../../assets/search_active_dark.svg";
import appsIconActiveLight from "../../../assets/search_active_light.svg";
import appsIconActiveDark from "../../../assets/search_active_dark.svg";
import closeIconLight from "../../../assets/close_light.svg";
import closeIconDark from "../../../assets/close_dark.svg";
import parametricIconLight from "../../../assets/parametric_light.svg";
import parametricIconDark from "../../../assets/parametric_dark.svg";
import parametricIconActiveLight from "../../../assets/parametric_light.svg";
import parametricIconActiveDark from "../../../assets/parametric_dark.svg";

// Replace chat icons with Noah icons
import noahIconDisabledLight from "../../../assets/noah_toolbar_light.svg";
import noahIconDisabledDark from "../../../assets/noah_toolbar_dark.svg";
import noahIconActiveLight from "../../../assets/diffusion_light.svg";
import noahIconActiveDark from "../../../assets/diffusion_dark.svg";
import noahIconHoverLight from "../../../assets/noah_hover_light.svg";
import noahIconHoverDark from "../../../assets/noah_hover_dark.svg";
import chevronIconLight from "../../../assets/chevron_light.svg";
import chevronIconDark from "../../../assets/chevron_dark.svg";
// AI icons for chat button
import aiIconLight from "../../../assets/add_light.svg";
import aiIconDark from "../../../assets/add_dark.svg";
import aiIconActiveLight from "../../../assets/add_light.svg";
import aiIconActiveDark from "../../../assets/add_dark.svg";
// Import all profile dropdown icons from ProjectLeftSidebar
import emailIconLight from "../../../assets/mail_light.svg";
import emailIconDark from "../../../assets/mail_dark.svg";
import creditsIconLight from "../../../assets/credits_light.svg";
import creditsIconDark from "../../../assets/credits_dark.svg";
import giftIconLight from "../../../assets/gift_light.svg";
import giftIconDark from "../../../assets/gift_dark.svg";
import themeIconLight from "../../../assets/theme_light.svg";
import themeIconDark from "../../../assets/theme_dark.svg";
import billingIconLight from "../../../assets/billing_light.svg";
import billingIconDark from "../../../assets/billing_dark.svg";
import accountIconLight from "../../../assets/settings_light.svg";
import accountIconDark from "../../../assets/settings_dark.svg";
import discordIconLight from "../../../assets/discord_light.svg";
import discordIconDark from "../../../assets/discord_dark.svg";
import feedbackIconLight from "../../../assets/feedback_light.svg";
import feedbackIconDark from "../../../assets/feedback_dark.svg";
import termsIconLight from "../../../assets/terms_light.svg";
import termsIconDark from "../../../assets/terms_dark.svg";
import policyIconLight from "../../../assets/policy_light.svg";
import policyIconDark from "../../../assets/policy_dark.svg";
import logoutIconLight from "../../../assets/logout_light.svg";
import logoutIconDark from "../../../assets/logout_dark.svg";
import sendIconLight from "../../../assets/external_light.svg";
import sendIconDark from "../../../assets/external_dark.svg";
import billingLoadLight from "../../../assets/billingLoad_light.svg";
import billingLoadDark from "../../../assets/billingLoad_dark.svg";

// Export and Share icons
import exportIconLight from "../../../assets/export_light.svg";
import exportIconDark from "../../../assets/export_dark.svg";
import exportIconActiveLight from "../../../assets/export_active_light.svg";
import exportIconActiveDark from "../../../assets/export_active_dark.svg";
import privateIconLight from "../../../assets/private_light.svg";
import publicIconLight from "../../../assets/public_light.svg";
import privateIconBlack from "../../../assets/private_black.svg";
import publicIconBlack from "../../../assets/public_black.svg";
import privateIconWhite from "../../../assets/private_white.svg";
import publicIconWhite from "../../../assets/public_white.svg";
import privateIconDark from "../../../assets/private_dark.svg";
import publicIconDark from "../../../assets/public_dark.svg";
import copyIconLight from "../../../assets/copy_message_light.svg";
import copyIconDark from "../../../assets/copy_message_dark.svg";
import checkIconLight from "../../../assets/check_light.svg";
import checkIconDark from "../../../assets/check_dark.svg";
import checkMessagesIconLight from "../../../assets/check_messages_light.svg";
import checkMessagesIconDark from "../../../assets/check_messages_dark.svg";

// Theme icons
import lightIconActiveLightTheme from "../../../assets/light_icon_active_light.svg";
import lightIconActiveDarkTheme from "../../../assets/light_icon_active_dark.svg";
import lightIconInactiveLightTheme from "../../../assets/light_icon_inactive_light.svg";
import lightIconInactiveDarkTheme from "../../../assets/light_icon_inactive_dark.svg";
import darkIconActiveLightTheme from "../../../assets/dark_icon_active_light.svg";
import darkIconActiveDarkTheme from "../../../assets/dark_icon_active_dark.svg";
import darkIconInactiveLightTheme from "../../../assets/dark_icon_inactive_light.svg";
import darkIconInactiveDarkTheme from "../../../assets/dark_icon_inactive_dark.svg";

import { useAuth } from "../../../components/Auth/AuthProvider";
import { useTheme } from "../../../App";
import { getFunctions, httpsCallable } from "firebase/functions";

interface TopToolbarProps {
  onModelsClick: () => void;
  onFeatureTreeClick: () => void;
  onChatClick: () => void;
  onShowCreditsModal: () => void;
  projectToHunt?: string | null;
  onShowReferralModal: () => void;
  refreshTrigger?: number; // ✅ ADD THIS
  optimisticProject?: { id: string; name: string; updatedAt?: Date } | null;
  onShowFeedbackModal: () => void;
  onNavigateToSettings?: () => void;
  isLeftSidebarOpen?: boolean;
  isRightSidebarOpen?: boolean;
  isModelsSidebarOpen?: boolean;
  activeProjectId?: string | null;
  activeProjectName?: string;
  isProjectPublic?: boolean;
  projectShareToken?: string;
  onExport?: (format: string) => void;
  onShareStatusChange?: () => void;
  onExportFormatChange?: (format: string) => void;
  isActiveTabShared?: boolean;
  onToolbarExpandChange?: (expanded: boolean) => void; // Add this
  onProjectSelect?: (projectId: string) => void; // ADD THIS
  onProjectRename?: (projectId: string, newName: string) => void; // Add this
  onProjectDelete?: (projectId: string) => Promise<void>; // Add this
  onExampleSelect?: (exampleId: string) => void; // ✅ ADD THIS
  loadingProjectId?: string | null; // ADD THIS
  isToolbarExpanded?: boolean; // ADD THIS
  onRefreshProjects?: () => void; // ADD THIS
  projects?: Array<{ id: string; name: string; updatedAt: Date }>; // ✅ ADDED THIS
}

const TopToolbar: React.FC<TopToolbarProps> = ({
  onModelsClick,
  onFeatureTreeClick,
  onChatClick,
  refreshTrigger = 0, // ✅ ADD THIS DEFAULT
  projectToHunt,
  onExampleSelect, // ✅ ADD THIS
  optimisticProject,
  onShowCreditsModal,
  onShowReferralModal,
  onShowFeedbackModal,
  onNavigateToSettings,
  isLeftSidebarOpen = false,
  isRightSidebarOpen = false,
  isModelsSidebarOpen = false,
  activeProjectId,
  activeProjectName,
  isProjectPublic = false,
  projectShareToken,
  onExport,
  onShareStatusChange,
  onExportFormatChange,
  isActiveTabShared = false,
  onProjectSelect, // ADD THIS LINE
  onToolbarExpandChange, // Add this
  onProjectRename, // ADD THIS LINE
  onProjectDelete, // ADD THIS LINE
  onRefreshProjects, // Make sure this is destructured
  loadingProjectId, // ADD THIS
  isToolbarExpanded = true, // ADD THIS with default
  projects = [], // ✅ ADDED THIS with default empty array
}) => {
  const { getIcon } = useThemedIcon();
  const noahExpandedIcon = getIcon(noahLighter, noahDarker);
  // const [toolbarProjects, setToolbarProjects] = useState<
  //   Array<{
  //     id: string;
  //     name: string;
  //     updatedAt: Date;
  //   }>
  // >([]);

  const deleteIcon = getIcon(deleteIconLight, deleteIconDark);
  const pinIcon = getIcon(pinIconLight, pinIconDark);
  const pinActiveIcon = getIcon(pinActiveIconLight, pinActiveIconDark);
  const unpinIcon = getIcon(unpinIconLight, unpinIconDark);

  const handleCloseDeleteModal = () => {
    if (isDeleting) return;
    setShowDeleteModal(false);
    setDeletingProjectId(null);
    setDeletingProjectName("");
  };
  const handleNoahClick = () => {
    if (isToolbarExpanded) {
      onChatClick();
      return;
    }

    onToolbarExpandChange?.(!isToolbarExpanded); // CHANGED: removed setIsToolbarExpanded
  };

  const handleCollapseClick = () => {
    onToolbarExpandChange?.(!isToolbarExpanded); // CHANGED: removed setIsToolbarExpanded
  };

  useEffect(() => {
    // Expose collapse function globally
    (window as any).__collapseTopToolbar = () => {
      if (isToolbarExpanded && onToolbarExpandChange) {
        onToolbarExpandChange(false);
      }
    };

    return () => {
      delete (window as any).__collapseTopToolbar;
    };
  }, [isToolbarExpanded, onToolbarExpandChange]);
  const { user, userProfile, logout, updateUserProfile } = useAuth();
  const { theme: activeTheme, setTheme: setActiveTheme } = useTheme();
  const closeIcon = getIcon(closeIconLight, closeIconDark);
  const [showSettingsModal, setShowSettingsModal] = useState(false);
  const [isSettingsModalOpen, setIsSettingsModalOpen] = useState(false);
  const [showCurrentPassword, setShowCurrentPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  // Settings states
  const [deletingProjectId, setDeletingProjectId] = useState<string | null>(
    null,
  );
  const [pinnedProjectIds, setPinnedProjectIds] = useState<Set<string>>(
    new Set(),
  );

  const getSubscriptionTier = () => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const tier = (userProfile as any)?.subscriptionTier || "free";
    return tier.charAt(0).toUpperCase() + tier.slice(1);
  };
  const EXAMPLE_PROJECT_IDS = [
    "S79Nx7xikgyBxC78ksSf",
    "VkQgP0JkSWZmM1jIjeJN",
    "LHIiWYRVduGrYUe6hAyb",
  ];
  const [profileButtonRect, setProfileButtonRect] = useState<DOMRect | null>(
    null,
  );
  const ellipsisIcon = getIcon(ellipsisIconLight, ellipsisIconDark);
  const ellipsisActiveIcon = getIcon(
    ellipsisActiveIconLight,
    ellipsisActiveIconDark,
  );
  const loadingIcon = getIcon(loadingIconLight, loadingIconDark);
  const featureIcon = getIcon(featureIconLight, featureIconDark);

  const renameIcon = getIcon(renameIconLight, renameIconDark);
  const [deletingProjectName, setDeletingProjectName] = useState<string>("");
  const warningIcon = getIcon(warningIconLight, warningIconDark);
  const checkIcon = getIcon(checkIconLight, checkIconDark);
  const checkMessagesIcon = getIcon(
    checkMessagesIconLight,
    checkMessagesIconDark,
  );
  const [hoveredTooltip, setHoveredTooltip] = useState<{
    text: string;
    command?: string;
    rect: DOMRect;
    type: "side" | "bottom";
  } | null>(null);
  const [hoveredModelId, setHoveredModelId] = useState<string | null>(null);
  const [openModelDropdown, setOpenModelDropdown] = useState<string | null>(
    null,
  );
  const profileDropdownRef = useRef<HTMLDivElement>(null);
  const [showTopBorder, setShowTopBorder] = useState(false);
  const [showBottomBorder, setShowBottomBorder] = useState(false);
  const [editingModelId, setEditingModelId] = useState<string | null>(null);
  const [modelDropdownPosition, setModelDropdownPosition] = useState<{
    top?: number;
    bottom?: number;
    left: number;
  } | null>(null);
  const modelDropdownRefs = useRef<{ [key: string]: HTMLDivElement | null }>(
    {},
  );
  const modelInputRefs = useRef<{ [key: string]: HTMLInputElement | null }>({});
  const modelMoreButtonRefs = useRef<{
    [key: string]: HTMLButtonElement | null;
  }>({});

  // TopToolbar.tsx

  const handleModelMoreClick = (e: React.MouseEvent, projectId: string) => {
    e.stopPropagation();

    if (openModelDropdown === projectId) {
      setOpenModelDropdown(null);
      setModelDropdownPosition(null);
      return;
    }

    const button = e.currentTarget as HTMLButtonElement;
    const toolbarButton = button.closest(`.${styles.toolbarButton}`);
    const toolbarRect = toolbarButton?.getBoundingClientRect();

    // Position directly below the toolbar button
    setModelDropdownPosition({
      top: toolbarRect?.bottom || 0,
      left: toolbarRect?.left || 0,
    });

    setOpenModelDropdown(projectId);
  };

  const handleModelRenameClick = (e: React.MouseEvent, projectId: string) => {
    e.stopPropagation();
    setEditingModelId(projectId);
    setOpenModelDropdown(null);
  };

  const handleModelDeleteClick = (
    e: React.MouseEvent,
    projectId: string,
    projectName: string,
  ) => {
    e.stopPropagation();
    setOpenModelDropdown(null);
    setDeletingProjectId(projectId); // ADD THIS LINE
    setDeletingProjectName(projectName);
    setShowDeleteModal(true);
  };

  useEffect(() => {
    if (!user) return;
    const loadPinnedProjects = async () => {
      try {
        const userDocRef = doc(db, "users", user.uid);
        const userDocSnap = await getDoc(userDocRef);
        if (userDocSnap.exists()) {
          const data = userDocSnap.data();
          const pinned: string[] = data?.pinnedProjectIds || [];
          setPinnedProjectIds(new Set(pinned));
        }
      } catch (error) {
        console.error("Error loading pinned projects:", error);
      }
    };
    loadPinnedProjects();
  }, [user]);

  // Around line 450, modify the handleClickOutside effect:
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (!openModelDropdown) return;
      const target = event.target as Element;
      const dropdown = document.querySelector(
        `[data-toolbar-dropdown-id="${openModelDropdown}"]`,
      );
      const moreButton = target.closest(`.${styles.moreButton}`);
      if (moreButton) return;
      if (dropdown && !dropdown.contains(target)) {
        setOpenModelDropdown(null);
        setHoveredModelId(null); // ADD THIS LINE
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [openModelDropdown]);

  // TopToolbar.tsx

  useEffect(() => {
    if (!openModelDropdown) return;

    const updatePosition = () => {
      const button = modelMoreButtonRefs.current[openModelDropdown];
      if (!button) return;

      const toolbarButton = button.closest(`.${styles.toolbarButton}`);
      const toolbarRect = toolbarButton?.getBoundingClientRect();

      if (toolbarRect) {
        setModelDropdownPosition({
          top: toolbarRect.bottom,
          left: toolbarRect.left,
        });
      }
    };

    const scrollContainer = document.querySelector(
      `.${styles.modelsListContainer}`,
    );
    scrollContainer?.addEventListener("scroll", updatePosition);
    window.addEventListener("resize", updatePosition);

    return () => {
      scrollContainer?.removeEventListener("scroll", updatePosition);
      window.removeEventListener("resize", updatePosition);
    };
  }, [openModelDropdown]);

  const handleModelNameBlur = async (
    projectId: string,
    currentName: string,
  ) => {
    const input = modelInputRefs.current[projectId];
    if (input) {
      const newName = input.value.trim();
      if (newName && newName !== currentName) {
        // ✅ CHANGED: Call parent prop instead of local update/refresh
        if (onProjectRename) {
          onProjectRename(projectId, newName);
        }
      }
    }
    setEditingModelId(null);
  };

  const handleModelNameKeyDown = async (
    e: React.KeyboardEvent,
    projectId: string,
    currentName: string,
  ) => {
    if (e.key === "Enter") {
      const input = modelInputRefs.current[projectId];
      if (input) {
        const newName = input.value.trim();
        if (newName && newName !== currentName) {
          // ✅ CHANGED: Call parent prop instead of local update/refresh
          if (onProjectRename) {
            onProjectRename(projectId, newName);
          }
        }
      }
      setEditingModelId(null);
    } else if (e.key === "Escape") {
      setEditingModelId(null);
    }
  };

  const handleModelDeleteConfirm = async () => {
    if (!deletingProjectId) return;

    setIsDeleting(true);
    try {
      // ✅ CHANGED: Call parent prop instead of local delete/refresh
      if (onProjectDelete) {
        await onProjectDelete(deletingProjectId);
      }

      // Close modal
      setShowDeleteModal(false);
      setDeletingProjectId(null);
      setDeletingProjectName("");
    } catch (error) {
      console.error("Error deleting project:", error);
    } finally {
      setIsDeleting(false);
    }
  };

  const handleModelPinToggle = async (
    e: React.MouseEvent,
    projectId: string,
  ) => {
    e.stopPropagation();
    setOpenModelDropdown(null);

    if (!user) return;

    const isCurrentlyPinned = pinnedProjectIds.has(projectId);
    const newPinnedIds = new Set(pinnedProjectIds);

    if (isCurrentlyPinned) {
      newPinnedIds.delete(projectId);
    } else {
      newPinnedIds.add(projectId);
    }

    setPinnedProjectIds(newPinnedIds);

    try {
      const userDocRef = doc(db, "users", user.uid);
      await updateDoc(userDocRef, {
        pinnedProjectIds: Array.from(newPinnedIds),
      });
    } catch (error) {
      console.error("Error saving pinned projects:", error);
      // Revert on failure
      setPinnedProjectIds(pinnedProjectIds);
    }
  };

  // ADD THIS NEW HELPER FUNCTION:
  const getActualDisplayTheme = (): "light" | "dark" => {
    if (activeTheme === "system") {
      // Check system preference
      return window.matchMedia("(prefers-color-scheme: dark)").matches
        ? "dark"
        : "light";
    }
    return activeTheme as "light" | "dark";
  };

  const visibleIcon = getIcon(visibleIconLight, visibleIconDark);
  const notVisibleIcon = getIcon(notVisibleIconLight, notVisibleIconDark);
  const [isEditingName, setIsEditingName] = useState(false);
  const [editedName, setEditedName] = useState(
    userProfile?.fullName || user?.displayName || "",
  );

  const [isSearching, setIsSearching] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const searchInputRef = useRef<HTMLInputElement>(null);
  const [profileImage, setProfileImage] = useState<string | null>(
    userProfile?.photoURL || user?.photoURL || null,
  );

  const handleModelsClick = () => {
    // If toolbar is collapsed, expand it AND toggle search mode
    if (!isToolbarExpanded) {
      onToolbarExpandChange?.(true);
      setIsSearching(true);
      // Focus the input after expansion
      setTimeout(() => {
        searchInputRef.current?.focus();
      }, 0);
      return;
    }

    // Toggle search mode instead of opening sidebar
    setIsSearching(!isSearching);
    if (!isSearching) {
      // Focus the input when entering search mode
      setTimeout(() => {
        searchInputRef.current?.focus();
      }, 0);
    } else {
      // Clear search when exiting
      setSearchQuery("");
    }
  };

  const allProjects = React.useMemo(() => {
    // 1. If we don't have an optimistic update, just return the passed list
    if (!optimisticProject) return projects;

    // 2. Check if the project already exists in the list (Rename scenario)
    const exists = projects.some((p) => p.id === optimisticProject.id);

    if (exists) {
      // RENAME SCENARIO: Update the name in place, preserve order
      return projects.map((p) =>
        p.id === optimisticProject.id
          ? { ...p, name: optimisticProject.name }
          : p,
      );
    } else {
      // CREATE/DUPLICATE SCENARIO:
      const newProject = {
        id: optimisticProject.id,
        name: optimisticProject.name,
        // ✅ Use specific date if provided (Examples), else "now" (New Projects)
        updatedAt: optimisticProject.updatedAt || new Date(),
      };

      // ✅ SORT instead of PREPEND
      // This ensures if we pass an old date (example), it lands in the middle
      const combined = [newProject, ...projects];
      return combined.sort(
        (a, b) => b.updatedAt.getTime() - a.updatedAt.getTime(),
      );
    }
  }, [projects, optimisticProject]);

  // Now filter the COMBINED list
  const filteredToolbarProjects = React.useMemo(() => {
    const filtered = allProjects.filter((project) =>
      project.name.toLowerCase().includes(searchQuery.toLowerCase()),
    );
    return filtered.sort((a, b) => {
      const aPinned = pinnedProjectIds.has(a.id);
      const bPinned = pinnedProjectIds.has(b.id);
      if (aPinned && !bPinned) return -1;
      if (!aPinned && bPinned) return 1;
      return 0; // preserve existing updatedAt order within each group
    });
  }, [allProjects, searchQuery, pinnedProjectIds]);
  // 👆 END OF NEW BLOCK 👆

  // Email editing states
  const [isEditingEmail, setIsEditingEmail] = useState(false);
  const [editedEmail, setEditedEmail] = useState("");
  const [emailConfirmPassword, setEmailConfirmPassword] = useState("");
  const [pendingEmail, setPendingEmail] = useState<string | null>(null);

  // Password editing states
  const [isEditingPassword, setIsEditingPassword] = useState(false);
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmNewPassword, setConfirmNewPassword] = useState("");
  const [passwordChangeSuccess, setPasswordChangeSuccess] = useState(false);

  // Delete account states
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);

  // Loading states
  const [isSavingName, setIsSavingName] = useState(false);
  const [isSavingEmail, setIsSavingEmail] = useState(false);
  const [isSavingPassword, setIsSavingPassword] = useState(false);
  const [isResendingEmail, setIsResendingEmail] = useState(false);

  // Error/success states
  const [settingsError, setSettingsError] = useState<string | null>(null);
  const [settingsSuccess, setSettingsSuccess] = useState<string | null>(null);

  // Add file input ref
  const fileInputRef = useRef<HTMLInputElement>(null);
  const [showProfileDropdown, setShowProfileDropdown] = useState(false);
  const [isBillingLoading, setIsBillingLoading] = useState(false);
  const [hoveredButton, setHoveredButton] = useState<string | null>(null);
  const [isExportDropdownOpen, setIsExportDropdownOpen] = useState(false);
  const [isShareDropdownOpen, setIsShareDropdownOpen] = useState(false);
  const [isCopiedShare, setIsCopiedShare] = useState(false);
  const [localIsPublic, setLocalIsPublic] = useState(false);
  const [localShareToken, setLocalShareToken] = useState<string | undefined>(
    undefined,
  );
  const sidebarIcon = getIcon(
    sidebarIconInactiveLight,
    sidebarIconInactiveDark,
  );
  const [isFeedbackModalOpen, setIsFeedbackModalOpen] = useState(false);
  const [isCreditsModalOpen, setIsCreditsModalOpen] = useState(false);
  const [showFeedbackModal, setShowFeedbackModal] = useState(false);
  const [feedbackText, setFeedbackText] = useState("");
  const [isSendingFeedback, setIsSendingFeedback] = useState(false);
  const [feedbackSubmitted, setFeedbackSubmitted] = useState(false);

  const dropdownRef = useRef<HTMLDivElement>(null);
  const exportDropdownRef = useRef<HTMLDivElement>(null);
  const shareDropdownRef = useRef<HTMLDivElement>(null);
  const shareDropdownShouldStayOpen = useRef(false); // ADD THIS LINE

  // Icons with active states and hover logic
  const appsIcon = getIcon(
    isModelsSidebarOpen || hoveredButton === "models"
      ? appsIconActiveLight
      : appsIconLight,
    isModelsSidebarOpen || hoveredButton === "models"
      ? appsIconActiveDark
      : appsIconDark,
  );

  const parametricIcon = getIcon(
    isLeftSidebarOpen || hoveredButton === "parametric"
      ? parametricIconActiveLight
      : parametricIconLight,
    isLeftSidebarOpen || hoveredButton === "parametric"
      ? parametricIconActiveDark
      : parametricIconDark,
  );

  const noahIcon = getIcon(
    hoveredButton === "chat"
      ? noahIconHoverLight
      : isRightSidebarOpen
        ? noahIconActiveLight
        : noahIconDisabledLight,
    hoveredButton === "chat"
      ? noahIconHoverDark
      : isRightSidebarOpen
        ? noahIconActiveDark
        : noahIconDisabledDark,
  );

  const aiIcon = getIcon(
    isRightSidebarOpen || hoveredButton === "chat"
      ? aiIconActiveLight
      : aiIconLight,
    isRightSidebarOpen || hoveredButton === "chat"
      ? aiIconActiveDark
      : aiIconDark,
  );

  const chevronIcon = getIcon(chevronIconLight, chevronIconDark);
  const emailIcon = getIcon(emailIconLight, emailIconDark);
  const creditsIcon = getIcon(creditsIconLight, creditsIconDark);
  const giftIcon = getIcon(giftIconLight, giftIconDark);
  const themeIcon = getIcon(themeIconLight, themeIconDark);
  const billingIcon = getIcon(billingIconLight, billingIconDark);
  const accountIcon = getIcon(accountIconLight, accountIconDark);
  const discordIcon = getIcon(discordIconLight, discordIconDark);
  const feedbackIcon = getIcon(feedbackIconLight, feedbackIconDark);
  const termsIcon = getIcon(termsIconLight, termsIconDark);
  const policyIcon = getIcon(policyIconLight, policyIconDark);
  const logoutIcon = getIcon(logoutIconLight, logoutIconDark);
  const sendIcon = getIcon(sendIconLight, sendIconDark);
  const billingLoad = getIcon(billingLoadLight, billingLoadDark);

  const exportIcon = getIcon(exportIconLight, exportIconDark);
  const exportIconActive = getIcon(exportIconActiveLight, exportIconActiveDark);
  const privateIconDefault = getIcon(privateIconLight, privateIconDark);
  const publicIconDefault = getIcon(publicIconLight, publicIconDark);
  const privateIconHover = getIcon(privateIconBlack, privateIconWhite);
  const publicIconHover = getIcon(publicIconBlack, publicIconWhite);
  const copyIconShare = getIcon(copyIconLight, copyIconDark);
  const checkIconShare = getIcon(checkIconLight, checkIconDark);

  const hasStripeCustomerId = !!userProfile?.stripeCustomerId;
  const displayName = userProfile?.fullName || user?.displayName || "User";

  // Auth method helper
  const getAuthMethod = () => {
    if (!user || !user.providerData || user.providerData.length === 0) {
      return "email";
    }
    const providerId = user.providerData[0].providerId;
    switch (providerId) {
      case "google.com":
        return "google";
      case "microsoft.com":
        return "microsoft";
      case "apple.com":
        return "apple";
      default:
        return "email";
    }
  };

  const authMethod = getAuthMethod();
  const isEmailAuth = authMethod === "email";

  // Validation helpers
  const isValidEmail = (email: string) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  // Settings modal handlers
  const handleOpenSettings = () => {
    setShowProfileDropdown(false);
    if (onNavigateToSettings) onNavigateToSettings();
  };

  const handleCloseSettingsModal = () => {
    setShowSettingsModal(false);
    setShowDeleteModal(false); // ADD THIS LINE
    setIsEditingName(false);
    setIsEditingEmail(false);
    setIsEditingPassword(false);
    setEditedName(userProfile?.fullName || user?.displayName || "");
    setEditedEmail("");
    setEmailConfirmPassword("");
    setCurrentPassword("");
    setNewPassword("");
    setConfirmNewPassword("");
    setSettingsError(null);
    setSettingsSuccess(null);
    setPasswordChangeSuccess(false);
    setPendingEmail(null);
    setTimeout(() => {
      setIsSettingsModalOpen(false);
    }, 100);
  };

  // Name change handlers
  const handleNameChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const newName = e.target.value;
    setEditedName(newName);

    // Auto-save after typing stops (debounce would be better in production)
    if (newName.trim().length > 0 && userProfile && updateUserProfile) {
      try {
        await updateUserProfile({
          fullName: newName.trim(),
          displayName: newName.trim(),
        });
      } catch (error) {
        // console.error("Error updating name:", error);
      }
    }
  };

  // Photo upload handlers
  const handleUploadClick = () => {
    fileInputRef.current?.click();
  };

  // Replace the handleFileChange function (around line 260)
  const handleFileChange = async (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const file = event.target.files?.[0];
    if (file && file.type.startsWith("image/")) {
      // Validate file size (max 5MB)
      if (file.size > 5 * 1024 * 1024) {
        setSettingsError("Image size must be less than 5MB");
        return;
      }

      try {
        // Show loading state
        setIsSavingName(true);

        // Create a reference to Firebase Storage
        const storageRef = ref(
          storage,
          `profilePhotos/${user!.uid}/${Date.now()}_${file.name}`,
        );

        // Upload the file
        await uploadBytes(storageRef, file);

        // Get the download URL
        const downloadURL = await getDownloadURL(storageRef);

        // console.log("📸 Photo uploaded to Storage:", downloadURL);

        // Update local state immediately for instant feedback
        setProfileImage(downloadURL);

        if (user && updateUserProfile) {
          // Update Firestore with the new photo URL
          await updateUserProfile({
            photoURL: downloadURL,
          });

          // console.log("✅ Firestore updated with photo URL");

          setSettingsSuccess("Profile photo updated successfully");

          // Clear success message after 3 seconds
          setTimeout(() => {
            setSettingsSuccess(null);
          }, 3000);
        }
      } catch (error) {
        // console.error("❌ Error updating profile photo:", error);
        setSettingsError("Failed to update profile photo. Please try again.");
        // Revert the local state if save failed
        setProfileImage(userProfile?.photoURL || user?.photoURL || null);
      } finally {
        setIsSavingName(false);
      }
    } else {
      setSettingsError("Please select a valid image file");
    }
  };

  // Add this useEffect after your other useEffects (around line 700)
  useEffect(() => {
    // Sync profileImage with userProfile when it changes
    if (userProfile?.photoURL) {
      // console.log(
      //   "🔄 Syncing profile image from userProfile:",
      //   userProfile.photoURL
      // );
      setProfileImage(userProfile.photoURL);
    }
  }, [userProfile?.photoURL]);

  // Email change handlers
  const handleChangeEmailClick = () => {
    setIsEditingEmail(true);
    setEditedEmail("");
    setEmailConfirmPassword("");
    setPendingEmail(null);
    setSettingsError(null);
    setSettingsSuccess(null);
  };

  const handleEmailSaveClick = async () => {
    if (!auth.currentUser || !editedEmail.trim() || !emailConfirmPassword)
      return;

    try {
      setIsSavingEmail(true);
      setSettingsError(null);

      const credential = EmailAuthProvider.credential(
        auth.currentUser.email!,
        emailConfirmPassword,
      );

      await reauthenticateWithCredential(auth.currentUser, credential);

      const actionCodeSettings = {
        url: window.location.origin,
        handleCodeInApp: true,
      };

      await verifyBeforeUpdateEmail(
        auth.currentUser,
        editedEmail.trim(),
        actionCodeSettings,
      );

      setPendingEmail(editedEmail.trim());
      setIsEditingEmail(false);
      setEmailConfirmPassword("");
      setEditedEmail("");
    } catch (error: any) {
      if (error.code === "auth/wrong-password") {
        setSettingsError("Current password is incorrect.");
      } else if (error.code === "auth/email-already-in-use") {
        setSettingsError("This email is already in use by another account.");
      } else if (error.code === "auth/invalid-email") {
        setSettingsError("Please enter a valid email address.");
      } else {
        setSettingsError(
          "Failed to send verification email. Please try again.",
        );
      }
    } finally {
      setIsSavingEmail(false);
    }
  };

  const handleResendVerificationEmail = async () => {
    if (!pendingEmail || !auth.currentUser) return;

    try {
      setIsResendingEmail(true);
      setSettingsError(null);

      const actionCodeSettings = {
        url: window.location.origin,
        handleCodeInApp: true,
      };

      await verifyBeforeUpdateEmail(
        auth.currentUser,
        pendingEmail,
        actionCodeSettings,
      );
      setSettingsSuccess("Verification link resent successfully.");
    } catch (error: any) {
      setSettingsError(
        "Failed to resend verification email. Please try again.",
      );
    } finally {
      setIsResendingEmail(false);
    }
  };

  // Password change handlers
  const handleChangePasswordClick = () => {
    setIsEditingPassword(true);
    setPasswordChangeSuccess(false);
    setCurrentPassword("");
    setNewPassword("");
    setConfirmNewPassword("");
    setSettingsError(null);
    setSettingsSuccess(null);
  };

  const handlePasswordSaveClick = async () => {
    if (!auth.currentUser || !currentPassword || newPassword.length < 8) return;

    if (newPassword !== confirmNewPassword) {
      setSettingsError("New passwords do not match.");
      return;
    }

    try {
      setIsSavingPassword(true);
      setSettingsError(null);

      const credential = EmailAuthProvider.credential(
        auth.currentUser.email!,
        currentPassword,
      );

      await reauthenticateWithCredential(auth.currentUser, credential);
      await updatePassword(auth.currentUser, newPassword);

      setPasswordChangeSuccess(true);
      setIsEditingPassword(false);
      setCurrentPassword("");
      setNewPassword("");
      setConfirmNewPassword("");
      setSettingsSuccess("Password changed successfully.");
    } catch (error: any) {
      if (error.code === "auth/wrong-password") {
        setSettingsError("Current password is incorrect.");
      } else if (error.code === "auth/weak-password") {
        setSettingsError(
          "New password is too weak. Please choose a stronger password.",
        );
      } else {
        setSettingsError("Failed to update password. Please try again.");
      }
    } finally {
      setIsSavingPassword(false);
    }
  };

  // Delete account handlers
  const handleDeleteAccount = () => {
    setShowDeleteModal(true);
    setSettingsError(null);
    setSettingsSuccess(null);
  };

  const handleDeleteConfirm = async () => {
    if (!auth.currentUser) return;

    setIsDeleting(true);
    try {
      const functions = getFunctions();
      const deleteAccount = httpsCallable(functions, "deleteUserAccount");

      await deleteAccount();
      await signOut(auth);
    } catch (error: any) {
      if (error.code === "auth/requires-recent-login") {
        setSettingsError(
          "Please log out and log back in, then try deleting again.",
        );
      } else {
        setSettingsError("Failed to delete account. Please try again.");
      }
      setShowDeleteModal(false);
      setIsDeleting(false);
    }
  };

  const handleDeleteCancel = () => {
    setShowDeleteModal(false);
  };

  const getCreditDisplay = () => {
    if (!userProfile) return "...";

    // Cast to 'any' to access the new database fields we just added
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const profile = userProfile as any;

    const tier = profile.subscriptionTier || "free";

    if (tier === "pro" || tier === "enterprise") {
      return "Unlimited";
    }

    const now = Date.now();
    const ONE_DAY_MS = 24 * 60 * 60 * 1000;
    const ONE_MONTH_MS = 30 * 24 * 60 * 60 * 1000;

    // --- 1. Calculate Monthly Usage ---
    const lastMonthlyReset = profile.lastMonthlyReset?.toMillis?.() || 0;
    let monthlyUsed = profile.monthlyFreeCreditsUsed ?? 0;

    // If month has passed, usage resets to 0
    if (now - lastMonthlyReset > ONE_MONTH_MS) {
      monthlyUsed = 0;
    }

    const MONTHLY_FREE_CAP = tier === "hobbyist" ? 150 : 30;

    // --- 2. Calculate Daily Credits ---
    const lastDailyReset = profile.lastDailyReset?.toMillis?.() || 0;
    let daily = profile.dailyCredits ?? 0;

    // If 24h passed, reset to 5 (UNLESS monthly cap is reached)
    if (now - lastDailyReset > ONE_DAY_MS) {
      if (monthlyUsed < MONTHLY_FREE_CAP) {
        daily = 5;
      } else {
        // Cap reached, no new daily credits
        daily = 0;
      }
    } else {
      // If within 24h but cap reached, valid daily credits are frozen
      if (monthlyUsed >= MONTHLY_FREE_CAP) {
        daily = 0;
      }
    }

    // --- 3. Rollover Credits ---
    const rollover = profile.credits || 0;

    // Total Available
    const total = daily + rollover;
    return `${total.toLocaleString()} left`;
  };

  // Get user avatar for display
  // Replace the existing getSettingsUserAvatar function (around line 300)
  const getSettingsUserAvatar = () => {
    const photoURL = profileImage || userProfile?.photoURL || user?.photoURL;

    // Check if photoURL is valid (not empty, null, undefined, or Gmail default)
    if (photoURL) {
      const trimmedURL = photoURL.trim();
      const isInvalidURL =
        trimmedURL === "" ||
        trimmedURL === "null" ||
        trimmedURL === "undefined" ||
        trimmedURL.includes("/avatar_default") ||
        trimmedURL.includes("default-avatar") ||
        trimmedURL.includes("blank-profile") ||
        trimmedURL.includes("s96-c/photo.jpg") ||
        trimmedURL.includes("googleusercontent.com/a-/default") ||
        trimmedURL.includes("lh3.googleusercontent.com/a/default") ||
        trimmedURL.includes("lh3.googleusercontent.com/a-/");

      if (!isInvalidURL) {
        return {
          type: "image" as const,
          value: trimmedURL,
        };
      }
    }

    // If no valid photo, return initials
    const name = userProfile?.fullName || user?.displayName || "User";
    const initials = name.charAt(0).toUpperCase();
    return {
      type: "initials" as const,
      value: initials,
    };
  };

  const handleSendFeedback = () => {
    setShowProfileDropdown(false);
    onShowFeedbackModal(); // This now opens FeedbackPage in CAD instead of the modal
  };

  const handleSubmitFeedback = async () => {
    if (!feedbackText.trim()) return;

    setIsSendingFeedback(true);
    try {
      const functions = getFunctions();
      const sendFeedbackEmail = httpsCallable(functions, "sendFeedbackEmail");

      await sendFeedbackEmail({
        feedback: feedbackText,
        userEmail: user?.email || "anonymous",
        userName:
          userProfile?.fullName || user?.displayName || "Anonymous User",
      });

      setFeedbackSubmitted(true);
    } catch (error) {
      // console.error("Error sending feedback:", error);
      // alert("Failed to send feedback. Please try again.");
    } finally {
      setIsSendingFeedback(false);
    }
  };

  const handleCloseFeedbackModal = () => {
    setShowFeedbackModal(false);
    setFeedbackText("");
    setFeedbackSubmitted(false);
    // Don't close the profile dropdown - remove the setShowProfileDropdown(false) line
  };

  // Close dropdown when clicking outside
  // Close dropdown when clicking outside
  // Close dropdown when clicking outside
  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const target = event.target as Element;

      // Don't close anything if any modal is currently open
      if (isCreditsModalOpen || isFeedbackModalOpen || isSettingsModalOpen) {
        return;
      }

      // Don't close dropdowns if clicking inside modal overlay or content
      const isModalClick =
        target.closest(`.${styles.modalOverlay}`) ||
        target.closest(`.${styles.creditsModalContent}`) ||
        target.closest(`.${styles.feedbackModalContent}`) ||
        target.closest(`.${styles.settingsModalContent}`);

      if (isModalClick) {
        return;
      }

      // Profile dropdown - check both the portal and the button
      if (showProfileDropdown) {
        const profileButton = target.closest(`.${styles.profileButton}`);
        const profileDropdown = profileDropdownRef.current;

        if (
          !profileButton &&
          (!profileDropdown || !profileDropdown.contains(target))
        ) {
          setShowProfileDropdown(false);
        }
      }

      // Other dropdowns
      if (
        exportDropdownRef.current &&
        !exportDropdownRef.current.contains(event.target as Node)
      ) {
        setIsExportDropdownOpen(false);
      }
      if (
        shareDropdownRef.current &&
        !shareDropdownRef.current.contains(event.target as Node)
      ) {
        setIsShareDropdownOpen(false);
      }
    };

    if (
      showProfileDropdown ||
      isExportDropdownOpen ||
      isShareDropdownOpen ||
      showFeedbackModal ||
      showSettingsModal
    ) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [
    showProfileDropdown,
    isExportDropdownOpen,
    isShareDropdownOpen,
    showFeedbackModal,
    showSettingsModal,
    isCreditsModalOpen,
    isFeedbackModalOpen,
    isSettingsModalOpen,
  ]);

  // Reset credits modal flag when clicking outside
  useEffect(() => {
    const resetCreditsModalFlag = () => {
      if (isCreditsModalOpen) {
        // Small delay to ensure modal close animation completes
        setTimeout(() => {
          setIsCreditsModalOpen(false);
        }, 100);
      }
    };

    document.addEventListener("mousedown", resetCreditsModalFlag);
    return () =>
      document.removeEventListener("mousedown", resetCreditsModalFlag);
  }, [isCreditsModalOpen]);

  // Reset feedback modal flag when clicking outside
  useEffect(() => {
    const resetFeedbackModalFlag = () => {
      if (isFeedbackModalOpen) {
        // Small delay to ensure modal close animation completes
        setTimeout(() => {
          setIsFeedbackModalOpen(false);
        }, 100);
      }
    };

    document.addEventListener("mousedown", resetFeedbackModalFlag);
    return () =>
      document.removeEventListener("mousedown", resetFeedbackModalFlag);
  }, [isFeedbackModalOpen]);

  // Sync share status from props to local state
  useEffect(() => {
    setLocalIsPublic(isProjectPublic || false);
    setLocalShareToken(projectShareToken);
  }, [isProjectPublic, projectShareToken]);

  // NEW: Always refresh share status when activeProjectId changes
  useEffect(() => {
    const loadShareStatus = async () => {
      if (!activeProjectId) {
        setLocalIsPublic(false);
        setLocalShareToken(undefined);
        return;
      }

      try {
        const projectDoc = await getDoc(doc(db, "projects", activeProjectId));
        if (projectDoc.exists()) {
          const data = projectDoc.data();

          const isPublic = data.isPublic || false;
          const token = data.shareToken;

          setLocalIsPublic(isPublic);
          setLocalShareToken(token);

          if (onShareStatusChange) {
            onShareStatusChange();
          }
        }
      } catch (error) {
        console.error("Error loading share status:", error);
      }
    };

    loadShareStatus();
  }, [activeProjectId, onShareStatusChange]);

  // Reset the flag after state updates
  useEffect(() => {
    if (shareDropdownShouldStayOpen.current) {
      // Small delay to ensure state has updated
      const timer = setTimeout(() => {
        shareDropdownShouldStayOpen.current = false;
      }, 100);
      return () => clearTimeout(timer);
    }
  }, [localIsPublic, localShareToken]);

  // TopToolbar.tsx ~ around line 1060

  // 👇 ADD THIS NEW BLOCK 👇
  // useEffect(() => {
  //   if (!projectToHunt || !user) return;

  //   // Check if we already have it in the list
  //   const found = toolbarProjects.some((p) => p.id === projectToHunt);
  //   if (found) return; // Found it! Stop hunting.

  //   console.log(`🔍 Hunting for project ${projectToHunt}...`);

  //   // Not found yet? Set up a polling interval
  //   const intervalId = setInterval(() => {
  //     loadToolbarProjects();
  //   }, 1000); // Try every 1 second

  //   // Safety timeout: stop trying after 20 seconds
  //   const timeoutId = setTimeout(() => {
  //     clearInterval(intervalId);
  //   }, 20000);

  //   return () => {
  //     clearInterval(intervalId);
  //     clearTimeout(timeoutId);
  //   };
  // }, [projectToHunt, toolbarProjects, user]);
  // 👆 END NEW BLOCK 👆

  // useEffect(() => {
  //   if (optimisticProject) {
  //     setToolbarProjects((prev) => {
  //       // 1. Check if it's already there to avoid duplicates
  //       if (prev.some((p) => p.id === optimisticProject.id)) return prev;

  //       // 2. Force it to the top of the list immediately
  //       return [
  //         {
  //           id: optimisticProject.id,
  //           name: optimisticProject.name,
  //           updatedAt: new Date(), // Give it a fresh timestamp
  //         },
  //         ...prev,
  //       ];
  //     });
  //   }
  // }, [optimisticProject]);
  // 👆 END NEW EFFECT 👆

  // Add this new function after loadToolbarProjects (around line 1050):
  // TopToolbar.tsx ~ line 1050

  // const loadToolbarProjects = async () => {
  //   if (!user) return;

  //   try {
  //     const q = query(
  //       collection(db, "projects"),
  //       where("userId", "==", user.uid),
  //       orderBy("updatedAt", "desc"),
  //     );

  //     const querySnapshot = await getDocs(q);
  //     const projects: typeof toolbarProjects = [];

  //     querySnapshot.forEach((doc) => {
  //       const data = doc.data();
  //       const safeToDate = (value: any): Date => {
  //         if (!value) return new Date(0);
  //         if (value.toDate) return value.toDate();
  //         if (value instanceof Date) return value;
  //         if (typeof value === "string") return new Date(value);
  //         return new Date(0);
  //       };

  //       projects.push({
  //         id: doc.id,
  //         name: data.name || "Untitled",
  //         updatedAt: safeToDate(data.updatedAt),
  //       });
  //     });

  //     // 👇👇👇 REPLACE THE setToolbarProjects CALL WITH THIS BLOCK 👇👇👇

  //     // If we have an optimistic project, FORCE it to be at the top
  //     // regardless of what the database just told us.
  //     if (optimisticProject) {
  //       // 1. Filter out the ID from the DB list (to prevent duplicates/stale data)
  //       const cleanList = projects.filter((p) => p.id !== optimisticProject.id);

  //       // 2. Prepend the optimistic project with "now" as the time
  //       setToolbarProjects([
  //         {
  //           id: optimisticProject.id,
  //           name: optimisticProject.name,
  //           updatedAt: new Date(), // Force it to be the newest
  //         },
  //         ...cleanList,
  //       ]);
  //     } else {
  //       // Standard behavior if no new project was just created
  //       setToolbarProjects(projects);
  //     }
  //     // 👆👆👆 END OF CHANGE 👆👆👆
  //   } catch (error) {
  //     console.error("Error loading toolbar projects:", error);
  //   }
  // };

  // Close dropdown when switching projects (but NOT when just updating share status)
  useEffect(() => {
    if (!shareDropdownShouldStayOpen.current) {
      setIsShareDropdownOpen(false);
    }

    // console.log(
    //   `🔄 TopToolbar: Updated for project ${activeProjectId}, isPublic: ${isProjectPublic}`
    // );
  }, [activeProjectId]);

  // Add this useEffect after your other useEffects (around line 900):
  useEffect(() => {
    if (!isSearching) return;

    const handleClickOutside = (event: MouseEvent) => {
      const target = event.target as Element;
      const searchContainer = target.closest(`.${styles.searchContainer}`);

      if (!searchContainer) {
        setIsSearching(false);
        setSearchQuery("");
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isSearching]);

  // Direct keyboard listener for Cmd+K (bypasses View.tsx)
  useEffect(() => {
    const handleGlobalKeyDown = (event: KeyboardEvent) => {
      const isMac = /Mac|iPhone|iPad|iPod/.test(navigator.userAgent);
      const modKey = isMac ? event.metaKey : event.ctrlKey;

      if (modKey && event.key.toLowerCase() === "k") {
        console.log("⌨️ Cmd+K detected in TopToolbar!");
        event.preventDefault();
        event.stopPropagation();

        // If toolbar is collapsed, expand it AND toggle search mode
        if (!isToolbarExpanded) {
          console.log("📂 Expanding toolbar and entering search mode");
          onToolbarExpandChange?.(true);
          setIsSearching(true);
          setTimeout(() => {
            searchInputRef.current?.focus();
          }, 0);
          return;
        }

        // Toggle search mode
        console.log("🔄 Toggling search mode");
        setIsSearching((prev) => !prev);
        if (!isSearching) {
          setTimeout(() => {
            searchInputRef.current?.focus();
          }, 0);
        } else {
          setSearchQuery("");
        }
      }
    };

    window.addEventListener("keydown", handleGlobalKeyDown, true); // ← Use capture phase
    return () =>
      window.removeEventListener("keydown", handleGlobalKeyDown, true);
  }, [isToolbarExpanded, isSearching, onToolbarExpandChange]);

  // Track scroll position to show borders when content is hidden
  // Track scroll position to show borders when content is hidden
  useEffect(() => {
    const modelsContainer = document.querySelector(
      `.${styles.modelsListContainer}`,
    );
    if (!modelsContainer) return;

    const handleScroll = () => {
      const scrollTop = modelsContainer.scrollTop;
      const scrollHeight = modelsContainer.scrollHeight;
      const clientHeight = modelsContainer.clientHeight;

      // Show bottom border on button section if content is scrolled up (hidden above)
      setShowBottomBorder(scrollTop > 0);

      // Show top border on profile section if there's scrollable content (models exist below)
      setShowTopBorder(scrollHeight > clientHeight);
    };

    // Initial check
    handleScroll();

    modelsContainer.addEventListener("scroll", handleScroll);
    // Also check when list changes size
    const resizeObserver = new ResizeObserver(handleScroll);
    resizeObserver.observe(modelsContainer);

    return () => {
      modelsContainer.removeEventListener("scroll", handleScroll);
      resizeObserver.disconnect();
    };
  }, [isToolbarExpanded, filteredToolbarProjects.length]);

  // Expose refresh function globally so RightSidebar can call it
  useEffect(() => {
    (window as any).__refreshTopToolbarProjects = async () => {
      // ✅ CHANGED: Call the prop if it exists, otherwise do nothing
      // (Since parent CAD.tsx now manages the list, it often refreshes itself)
      if (onRefreshProjects) {
        onRefreshProjects();
      }
    };

    return () => {
      delete (window as any).__refreshTopToolbarProjects;
    };
  }, [onRefreshProjects]);

  useEffect(() => {
    // Expose search toggle function globally for keyboard shortcut
    (window as any).__toggleTopToolbarSearch = () => {
      console.log(
        "🔍 __toggleTopToolbarSearch called, isToolbarExpanded:",
        isToolbarExpanded,
        "isSearching:",
        isSearching,
      );

      // If toolbar is collapsed, expand it AND toggle search mode
      if (!isToolbarExpanded) {
        console.log("📂 Expanding toolbar and entering search mode");
        onToolbarExpandChange?.(true);
        setIsSearching(true);
        // Focus the input after expansion
        setTimeout(() => {
          searchInputRef.current?.focus();
        }, 0);
        return;
      }

      // Toggle search mode
      console.log("🔄 Toggling search mode:", !isSearching);
      setIsSearching(!isSearching);
      if (!isSearching) {
        // Focus the input when entering search mode
        setTimeout(() => {
          searchInputRef.current?.focus();
        }, 0);
      } else {
        // Clear search when exiting
        setSearchQuery("");
      }
    };

    return () => {
      delete (window as any).__toggleTopToolbarSearch;
    };
  }, [isToolbarExpanded, isSearching, onToolbarExpandChange]);
  // REPLACE getLightModeIcon with this:
  const getLightModeIcon = () => {
    const isLightModeActive = activeTheme === "light";
    const currentDisplayTheme = getActualDisplayTheme();

    if (currentDisplayTheme === "light") {
      return isLightModeActive
        ? lightIconActiveLightTheme
        : lightIconInactiveLightTheme;
    } else {
      return isLightModeActive
        ? lightIconActiveDarkTheme
        : lightIconInactiveDarkTheme;
    }
  };

  // REPLACE getDarkModeIcon with this:
  const getDarkModeIcon = () => {
    const isDarkModeActive = activeTheme === "dark";
    const currentDisplayTheme = getActualDisplayTheme();

    if (currentDisplayTheme === "light") {
      return isDarkModeActive
        ? darkIconActiveLightTheme
        : darkIconInactiveLightTheme;
    } else {
      return isDarkModeActive
        ? darkIconActiveDarkTheme
        : darkIconInactiveDarkTheme;
    }
  };

  // ADD THIS NEW FUNCTION:
  const getSystemModeIcon = () => {
    const isSystemModeActive = activeTheme === "system";
    const currentDisplayTheme = getActualDisplayTheme();

    if (currentDisplayTheme === "light") {
      return isSystemModeActive
        ? systemIconActiveLightTheme
        : systemIconInactiveLightTheme;
    } else {
      return isSystemModeActive
        ? systemIconActiveDarkTheme
        : systemIconInactiveDarkTheme;
    }
  };

  const getUserAvatar = () => {
    const displayName =
      userProfile?.fullName ||
      user?.displayName ||
      user?.email?.split("@")[0] ||
      "User";

    let photoURL = userProfile?.photoURL || user?.photoURL;

    if (photoURL) {
      photoURL = photoURL.trim();
      if (photoURL === "" || photoURL === "null" || photoURL === "undefined") {
        photoURL = null;
      }

      // Check if it's a Gmail default avatar pattern
      const isGmailDefault =
        photoURL &&
        (photoURL.includes("/avatar_default") ||
          photoURL.includes("default-avatar") ||
          photoURL.includes("blank-profile") ||
          photoURL.includes("s96-c/photo.jpg") ||
          photoURL.includes("googleusercontent.com/a-/default") ||
          photoURL.includes("lh3.googleusercontent.com/a/default") ||
          photoURL.includes("lh3.googleusercontent.com/a-/"));

      // If it's a Gmail default, treat it as no photo
      if (isGmailDefault) {
        photoURL = null;
      }
    }

    if (photoURL) {
      return {
        type: "image" as const,
        value: photoURL,
      };
    }

    const initials = displayName.charAt(0).toUpperCase();
    return {
      type: "initials" as const,
      value: initials,
    };
  };

  const getAuthProviderIcon = (): {
    type: "svg" | "component";
    icon: string | React.ReactElement;
  } => {
    if (!user)
      return {
        type: "component",
        icon: (
          <img
            src={emailIcon}
            alt="Email"
            style={{ width: "0.875rem", height: "0.875rem" }}
          />
        ),
      };

    if (user.providerData && user.providerData.length > 0) {
      const providerId = user.providerData[0].providerId;
      switch (providerId) {
        case "google.com":
          return {
            type: "component",
            icon: (
              <svg width="0.875rem" height="0.875rem" viewBox="0 0 24 24">
                <path
                  fill="#4285F4"
                  d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
                />
                <path
                  fill="#34A853"
                  d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
                />
                <path
                  fill="#FBBC05"
                  d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
                />
                <path
                  fill="#EA4335"
                  d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
                />
              </svg>
            ),
          };
        case "microsoft.com":
          return {
            type: "component",
            icon: (
              <svg width="0.875rem" height="0.875rem" viewBox="0 0 24 24">
                <path fill="#F25022" d="M1 1h10v10H1z" />
                <path fill="#00A4EF" d="M13 1h10v10H13z" />
                <path fill="#7FBA00" d="M1 13h10v10H1z" />
                <path fill="#FFB900" d="M13 13h10v10H13z" />
              </svg>
            ),
          };
        case "apple.com":
          return {
            type: "component",
            icon: (
              <svg
                width="0.875rem"
                height="0.875rem"
                viewBox="0 0 24 24"
                fill="var(--color-black)"
              >
                <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.81-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z" />
              </svg>
            ),
          };
        default:
          return {
            type: "component",
            icon: (
              <img
                src={emailIcon}
                alt="Email"
                style={{ width: "0.875rem", height: "0.875rem" }}
              />
            ),
          };
      }
    }
    return {
      type: "component",
      icon: (
        <img
          src={emailIcon}
          alt="Email"
          style={{ width: "0.875rem", height: "0.875rem" }}
        />
      ),
    };
  };

  // REPLACE the entire handleThemeToggle function with this:
  const handleThemeToggle = async (
    theme: "light" | "dark" | "system", // Added "system" here
    e?: React.MouseEvent,
  ) => {
    if (e) {
      e.stopPropagation();
    }

    document.documentElement.classList.add("theme-transitioning");
    setActiveTheme(theme);

    setTimeout(() => {
      document.documentElement.classList.remove("theme-transitioning");
    }, 0);

    if (userProfile) {
      try {
        await updateUserProfile({ themePreference: theme });
      } catch (error) {
        // console.error("Error saving theme preference:", error);
      }
    }
  };

  const handleBillingClick = async (e: React.MouseEvent) => {
    e.stopPropagation();
    setIsBillingLoading(true);

    sessionStorage.setItem("billing_return_url", window.location.href);

    try {
      const functions = getFunctions();
      const createCustomerPortalSession = httpsCallable(
        functions,
        "createCustomerPortalSession",
      );

      const { data } = await createCustomerPortalSession({
        returnUrl: window.location.origin + "/?billing_return=true",
      });

      window.location.href = (data as any).url;
    } catch (error) {
      // console.error("Error opening customer portal:", error);
      setIsBillingLoading(false);
    }
  };

  const handleLogout = async () => {
    try {
      await logout();
      setShowProfileDropdown(false);
      window.history.pushState({}, "", "/login");
      window.location.reload();
    } catch (error) {
      // console.error("Error logging out:", error);
    }
  };

  const handleJoinCommunity = () => {
    window.open("https://discord.gg/mYG5ZDfmP7", "_blank");
    setShowProfileDropdown(false);
  };

  const generateShareToken = () => {
    return (
      Math.random().toString(36).substring(2, 15) +
      Math.random().toString(36).substring(2, 15)
    );
  };

  const handleSharePrivateClick = async () => {
    if (!activeProjectId) return;
    shareDropdownShouldStayOpen.current = true; // ADD THIS LINE
    try {
      await updateDoc(doc(db, "projects", activeProjectId), {
        isPublic: false,
        updatedAt: new Date(),
      });
      setLocalIsPublic(false);
      if (onShareStatusChange) {
        onShareStatusChange();
      }
    } catch (error) {
      // console.error("Error setting project to private:", error);
    }
  };

  const handleSharePublicClick = async () => {
    if (!activeProjectId) return;
    shareDropdownShouldStayOpen.current = true; // ADD THIS LINE
    try {
      let token = localShareToken;
      if (!token) {
        token = generateShareToken();
        setLocalShareToken(token);
      }
      await updateDoc(doc(db, "projects", activeProjectId), {
        isPublic: true,
        shareToken: token,
        updatedAt: new Date(),
      });
      setLocalIsPublic(true);

      const shareUrl = `${window.location.origin}/share/${token}`;
      navigator.clipboard.writeText(shareUrl);
      setIsCopiedShare(true);
      setTimeout(() => {
        setIsCopiedShare(false);
      }, 2000);

      if (onShareStatusChange) {
        onShareStatusChange();
      }
    } catch (error) {
      // console.error("Error setting project to public:", error);
    }
  };

  const handleCopyShareLink = () => {
    if (localShareToken) {
      const shareUrl = `${window.location.origin}/share/${localShareToken}`;
      navigator.clipboard.writeText(shareUrl);
      setIsCopiedShare(true);
      setTimeout(() => {
        setIsCopiedShare(false);
      }, 2000);
    }
  };

  const userAvatar = getUserAvatar();

  // Detect if user is on Mac/Apple device
  const isMac = /Mac|iPhone|iPad|iPod/.test(navigator.userAgent);
  const modifierKey = isMac ? "⌘" : "Ctrl";

  return (
    <>
      <div
        className={`${styles.toolbar} ${isToolbarExpanded ? styles.expanded : ""}`}
      >
        <div className={styles.leftSection}>
          {/* Noah Icon - Clickable to toggle expansion */}
          <div
            className={`${styles.noahLogoContainer} ${!isToolbarExpanded ? styles.collapsible : ""}`}
            onClick={(e) => {
              setHoveredTooltip(null); // ADD THIS
              handleNoahClick();
            }}
            onMouseEnter={(e) => {
              if (!isToolbarExpanded) {
                setHoveredButton("noah-collapse");
                // setHoveredTooltip({
                //   text: "Open sidebar",
                //   rect: e.currentTarget.getBoundingClientRect(),
                //   type: "side",
                // });
              }
            }}
            onMouseLeave={() => {
              setHoveredButton(null);
              setHoveredTooltip(null);
            }}
          >
            <img
              src={
                isToolbarExpanded
                  ? noahExpandedIcon
                  : hoveredButton === "noah-collapse"
                    ? getIcon(sidebarIconInactiveLight, sidebarIconInactiveDark)
                    : getIcon(noahIconActiveLight, noahIconActiveDark)
              }
              alt="Noah"
              className={styles.noahLogo}
              style={
                !isToolbarExpanded && hoveredButton === "noah-collapse"
                  ? { width: "16px", height: "16px" }
                  : {}
              }
            />
          </div>

          {/* Collapse button - only show when expanded */}
          {isToolbarExpanded && (
            <button
              className={styles.collapseButton}
              onClick={(e) => {
                setHoveredTooltip(null); // ADD THIS
                handleCollapseClick();
              }}
              onMouseEnter={(e) => {
                setHoveredButton("collapse");
                // setHoveredTooltip({
                //   text: "Close sidebar",
                //   rect: e.currentTarget.getBoundingClientRect(),
                //   type: "bottom",
                // });
              }}
              onMouseLeave={() => {
                setHoveredButton(null);
                setHoveredTooltip(null);
              }}
            >
              <img
                src={sidebarIcon}
                alt="Collapse"
                className={styles.collapseIcon}
              />
            </button>
          )}
        </div>

        <div className={styles.rightSection}>
          {/* Chat Button - First */}
          {/* Chat Button - First */}

          <div
            className={styles.fixedButtonsContainer}
            style={{
              borderBottom:
                showBottomBorder && isToolbarExpanded
                  ? "1px solid var(--color-border)"
                  : "none",
            }}
          >
            {/* Chat Button */}
            <button
              className={`${styles.toolbarButton} ${
                isRightSidebarOpen ? styles.active : ""
              }`}
              onClick={() => {
                setHoveredTooltip(null);
                onChatClick(); // ← Remove the if (!isRightSidebarOpen) condition
              }}
              onMouseEnter={(e) => {
                setHoveredButton("chat");
                if (!isToolbarExpanded) {
                  // setHoveredTooltip({
                  //   text: "New model",
                  //   command: modifierKey + "J",
                  //   rect: e.currentTarget.getBoundingClientRect(),
                  //   type: "side",
                  // });
                }
              }}
              onMouseLeave={() => {
                setHoveredButton(null);
                setHoveredTooltip(null);
              }}
            >
              <img src={aiIcon} alt="Chat" className={styles.buttonIcon} />
              {isToolbarExpanded && (
                <>
                  <span className={styles.buttonLabel}>New model</span>
                  {hoveredButton === "chat" && (
                    <span className={styles.buttonCommand}>{modifierKey}J</span>
                  )}
                </>
              )}
            </button>

            {/* Feature Tree Button */}
            {/* {activeProjectId && (
              <button
                className={`${styles.toolbarButton} ${
                  isLeftSidebarOpen ? styles.active : ""
                }`}
                onClick={() => {
                  setHoveredTooltip(null);
                  if (!isLeftSidebarOpen) {
                    onFeatureTreeClick();
                  }
                }}
                onMouseEnter={(e) => {
                  setHoveredButton("parametric");
                  if (!isToolbarExpanded) {
                    setHoveredTooltip({
                      text: "Feature tree",
                      command: modifierKey + "F",
                      rect: e.currentTarget.getBoundingClientRect(),
                      type: "side",
                    });
                  }
                }}
                onMouseLeave={() => {
                  setHoveredButton(null);
                  setHoveredTooltip(null);
                }}
              >
                <img
                  src={featureIcon}
                  alt="Feature tree"
                  className={styles.buttonIcon}
                />
                {isToolbarExpanded && (
                  <>
                    <span className={styles.buttonLabel}>Feature tree</span>
                    {hoveredButton === "parametric" && (
                      <span className={styles.buttonCommand}>
                        {modifierKey}F
                      </span>
                    )}
                  </>
                )}
              </button>
            )} */}

            {/* Models Button / Search */}
            {/* {!isSearching ? (
              <button
                className={`${styles.toolbarButton} ${
                  isModelsSidebarOpen ? styles.active : ""
                }`}
                onClick={() => {
                  setHoveredTooltip(null);
                  handleModelsClick();
                }}
                onMouseEnter={(e) => {
                  setHoveredButton("models");
                  if (!isToolbarExpanded) {
                    setHoveredTooltip({
                      text: "Search",
                      command: modifierKey + "K",
                      rect: e.currentTarget.getBoundingClientRect(),
                      type: "side",
                    });
                  }
                }}
                onMouseLeave={() => {
                  setHoveredButton(null);
                  setHoveredTooltip(null);
                }}
              >
                <img
                  src={appsIcon}
                  alt="Models"
                  className={styles.buttonIcon}
                />
                {isToolbarExpanded && (
                  <>
                    <span className={styles.buttonLabel}>Search</span>
                    {hoveredButton === "models" && (
                      <span className={styles.buttonCommand}>
                        {modifierKey}K
                      </span>
                    )}
                  </>
                )}
              </button>
            ) : (
              <div className={styles.searchContainer}>
                <img
                  src={appsIcon}
                  alt="Search"
                  className={styles.searchIconButton}
                />
                <input
                  ref={searchInputRef}
                  type="text"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  className={styles.searchInput}
                />
              </div>
            )} */}
          </div>

          {/* Models List - Only show when expanded */}
          {isToolbarExpanded && (
            <>
              <div className={styles.modelsListContainer}>
                <div className={styles.modelsListInner}>
                  {/* Only show "Recents" if there are actual projects to display */}
                  {filteredToolbarProjects.length > 0 && (
                    <div className={styles.modelsListLabel}>Recents</div>
                  )}

                  {filteredToolbarProjects.length === 0 && isSearching ? (
                    <div className={styles.emptySearchState}>
                      <div className={styles.emptySearchTitle}>
                        No models found
                      </div>
                      <div className={styles.emptySearchSubtitle}>
                        Try adjusting your search query
                      </div>
                    </div>
                  ) : (
                    filteredToolbarProjects.map((project) => {
                      const isEditing = editingModelId === project.id;
                      const isDropdownOpen = openModelDropdown === project.id;
                      const isEllipsisHovered = hoveredModelId === project.id;
                      const isCurrentProject = activeProjectId === project.id;
                      const isLoading = loadingProjectId === project.id;
                      const isAnyLoading = loadingProjectId != null;

                      // ✅ NEW: Check if this is an example project
                      const isExample = EXAMPLE_PROJECT_IDS.includes(
                        project.id,
                      );

                      const isDisabled =
                        isCurrentProject || (isAnyLoading && !isLoading);

                      const shouldShowHover =
                        isEllipsisHovered || isDropdownOpen;
                      const shouldShowActive = isCurrentProject;

                      return (
                        <React.Fragment key={project.id}>
                          <div
                            className={`${styles.toolbarButton} ${
                              shouldShowActive ? styles.active : ""
                            } ${isEditing ? styles.editing : ""} ${
                              (shouldShowHover || isDropdownOpen) &&
                              !isCurrentProject
                                ? styles.toolbarButtonHovered
                                : ""
                            } ${isCurrentProject ? styles.toolbarButtonDisabled : ""} ${
                              isLoading ? styles.toolbarButtonLoading : ""
                            } ${isDropdownOpen ? styles.toolbarButtonDropdownOpen : ""}`}
                            style={{ position: "relative" }}
                            onMouseEnter={() => {
                              setHoveredModelId(project.id);
                            }}
                            onMouseLeave={() => {
                              if (!isDropdownOpen) {
                                setHoveredModelId(null);
                              }
                            }}
                            onClick={() => {
                              if (!isEditing && !isDisabled) {
                                if (isExample && onExampleSelect) {
                                  onExampleSelect(project.id);
                                } else if (onProjectSelect) {
                                  onProjectSelect(project.id);
                                }
                              }
                            }}
                          >
                            <button
                              className={styles.modelButton}
                              onClick={(e) => {
                                e.stopPropagation();
                                if (!isEditing && !isDisabled) {
                                  if (isExample && onExampleSelect) {
                                    onExampleSelect(project.id);
                                  } else if (onProjectSelect) {
                                    onProjectSelect(project.id);
                                  }
                                }
                              }}
                              style={{
                                cursor: isDisabled ? "not-allowed" : "pointer",
                              }}
                              disabled={isDisabled}
                            >
                              {isEditing ? (
                                <input
                                  ref={(el) => {
                                    if (
                                      el &&
                                      !modelInputRefs.current[project.id]
                                    ) {
                                      modelInputRefs.current[project.id] = el;
                                      el.focus();
                                      el.select();
                                    } else if (el) {
                                      modelInputRefs.current[project.id] = el;
                                    }
                                  }}
                                  type="text"
                                  defaultValue={project.name}
                                  onKeyDown={(e) =>
                                    handleModelNameKeyDown(
                                      e,
                                      project.id,
                                      project.name,
                                    )
                                  }
                                  onBlur={() =>
                                    handleModelNameBlur(
                                      project.id,
                                      project.name,
                                    )
                                  }
                                  className={styles.modelNameInput}
                                  onClick={(e) => e.stopPropagation()}
                                />
                              ) : (
                                <span className={styles.buttonLabel}>
                                  {project.name}
                                </span>
                              )}
                            </button>

                            {!isEditing && !isExample && (
                              <div className={styles.rightButtonGroup}>
                                {isLoading ? (
                                  <div className={styles.loadingIndicator}>
                                    <img
                                      src={loadingIcon}
                                      alt="Loading"
                                      className={styles.loadingIcon}
                                    />
                                  </div>
                                ) : (
                                  !isCurrentProject && (
                                    <button
                                      className={`${styles.moreButton} ${isDropdownOpen ? styles.active : ""}`}
                                      onClick={(e) =>
                                        handleModelMoreClick(e, project.id)
                                      }
                                      onMouseEnter={() =>
                                        setHoveredModelId(project.id)
                                      }
                                      style={{
                                        opacity:
                                          isEllipsisHovered || isDropdownOpen
                                            ? 1
                                            : 0,
                                        visibility:
                                          isEllipsisHovered || isDropdownOpen
                                            ? "visible"
                                            : "hidden",
                                        width:
                                          isEllipsisHovered || isDropdownOpen
                                            ? "0.875rem"
                                            : "0",
                                      }}
                                    >
                                      <img
                                        src={
                                          isEllipsisHovered || isDropdownOpen
                                            ? ellipsisActiveIcon
                                            : ellipsisIcon
                                        }
                                        alt="More"
                                        className={styles.ellipsisIcon}
                                      />
                                    </button>
                                  )
                                )}
                                {pinnedProjectIds.has(project.id) && (
                                  <button
                                    className={styles.pinActiveButton}
                                    onClick={(e) => {
                                      e.stopPropagation();
                                    }}
                                    onMouseEnter={() =>
                                      setHoveredModelId(project.id)
                                    }
                                  >
                                    <img
                                      src={pinActiveIcon}
                                      alt="Pinned"
                                      className={styles.pinActiveIcon}
                                    />
                                  </button>
                                )}
                              </div>
                            )}
                          </div>

                          {/* Dropdown options inline */}
                          {isDropdownOpen && (
                            <>
                              <div
                                className={styles.modelDropdownOption}
                                onClick={(e) =>
                                  handleModelPinToggle(e, project.id)
                                }
                              >
                                <img
                                  src={
                                    pinnedProjectIds.has(project.id)
                                      ? unpinIcon
                                      : pinIcon
                                  }
                                  alt={
                                    pinnedProjectIds.has(project.id)
                                      ? "Unpin"
                                      : "Pin"
                                  }
                                  className={styles.modelDropdownIcon}
                                />
                                <span className={styles.modelDropdownText}>
                                  {pinnedProjectIds.has(project.id)
                                    ? "Unpin"
                                    : "Pin"}
                                </span>
                              </div>
                              <div
                                className={styles.modelDropdownOption}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleModelRenameClick(e, project.id);
                                }}
                              >
                                <img
                                  src={renameIcon}
                                  alt="Rename"
                                  className={styles.modelDropdownIcon}
                                />
                                <span className={styles.modelDropdownText}>
                                  Rename
                                </span>
                              </div>
                              <div
                                className={`${styles.modelDropdownOption} ${styles.modelDeleteOption}`}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleModelDeleteClick(
                                    e,
                                    project.id,
                                    project.name,
                                  );
                                }}
                              >
                                <img
                                  src={deleteIcon}
                                  alt="Delete"
                                  className={styles.modelDropdownIcon}
                                />
                                <span className={styles.modelDropdownText}>
                                  Delete
                                </span>
                              </div>
                            </>
                          )}
                        </React.Fragment>
                      );
                    })
                  )}
                </div>
              </div>
            </>
          )}

          {/* Export Button - Only show when a project is active */}
          {/* {activeProjectId && (
            <div
              className={styles.toolbarButtonContainer}
              ref={exportDropdownRef}
            >
              <button
                className={`${styles.toolbarButton} ${
                  isExportDropdownOpen ? styles.active : ""
                }`}
                onClick={() => setIsExportDropdownOpen(!isExportDropdownOpen)}
                onMouseEnter={() => setHoveredButton("export")}
                onMouseLeave={() => setHoveredButton(null)}
              >
                <img
                  src={
                    isExportDropdownOpen || hoveredButton === "export"
                      ? exportIconActive
                      : exportIcon
                  }
                  alt="Export"
                  className={styles.buttonIcon}
                />
                <span className={styles.buttonLabel}>Export</span>
                {!isExportDropdownOpen && !isToolbarExpanded && (
                  <div className={styles.tooltip}>Export</div>
                )}
              </button>

              {isExportDropdownOpen && (
                <div className={styles.headerDropdownMenu}>
                  <div
                    className={styles.exportOption}
                    onClick={(e) => {
                      e.stopPropagation();
                      if (onExport) onExport(".STL");
                    }}
                  >
                    <div className={styles.exportOptionMain}>.STL</div>
                    <div className={styles.exportOptionSub}>3D Printing</div>
                  </div>
                  <div
                    className={styles.exportOption}
                    onClick={(e) => {
                      e.stopPropagation();
                      if (onExport) onExport(".STEP");
                    }}
                  >
                    <div className={styles.exportOptionMain}>.STEP</div>
                    <div className={styles.exportOptionSub}>CAD Exchange</div>
                  </div>
                </div>
              )}
            </div>
          )} */}

          {/* Share Button - Only show when a project is active */}
          {/* {activeProjectId && !isActiveTabShared && (
            <div
              className={styles.toolbarButtonContainer}
              ref={shareDropdownRef}
            >
              <button
                className={`${styles.toolbarButton} ${
                  isShareDropdownOpen ? styles.active : ""
                }`}
                onClick={() => setIsShareDropdownOpen(!isShareDropdownOpen)}
                onMouseEnter={() => setHoveredButton("share")}
                onMouseLeave={() => setHoveredButton(null)}
              >
                <img
                  src={
                    isShareDropdownOpen || hoveredButton === "share"
                      ? localIsPublic
                        ? publicIconHover
                        : privateIconHover
                      : localIsPublic
                        ? publicIconDefault
                        : privateIconDefault
                  }
                  alt={localIsPublic ? "Public" : "Private"}
                  className={styles.buttonIcon}
                />
                <span className={styles.buttonLabel}>
                  {localIsPublic ? "Public" : "Private"}
                </span>
                {!isShareDropdownOpen && !isToolbarExpanded && (
                  <div className={styles.tooltip}>
                    {localIsPublic ? "Public" : "Private"}
                  </div>
                )}
              </button>
              {isShareDropdownOpen && (
                <div
                  className={styles.headerDropdownMenu}
                  onClick={(e) => e.stopPropagation()}
                >
                  <div
                    className={`${styles.shareOption} ${
                      !localIsPublic ? styles.shareOptionSelected : ""
                    }`}
                    onClick={(e) => {
                      e.stopPropagation();
                      handleSharePrivateClick();
                    }}
                  >
                    <div className={styles.shareOptionContent}>
                      <div className={styles.shareOptionMain}>Private</div>
                      <div className={styles.shareOptionSub}>
                        Only you can edit
                      </div>
                    </div>
                  </div>
                  <div
                    className={`${styles.shareOption} ${
                      localIsPublic ? styles.shareOptionSelected : ""
                    }`}
                    onClick={(e) => {
                      e.stopPropagation();
                      handleSharePublicClick();
                    }}
                  >
                    <div className={styles.shareOptionContent}>
                      <div className={styles.shareOptionMain}>Public</div>
                      <div className={styles.shareOptionSub}>
                        Anyone with the link can view
                      </div>
                      {localIsPublic && localShareToken && (
                        <div
                          className={styles.shareLinkBox}
                          onClick={(e) => {
                            e.stopPropagation();
                            handleCopyShareLink();
                          }}
                        >
                          <div className={styles.shareLinkText}>
                            {`${window.location.origin}/share/${localShareToken}`}
                          </div>
                          <div className={styles.copyShareIcon}>
                            <img
                              src={
                                isCopiedShare
                                  ? checkMessagesIcon
                                  : copyIconShare
                              }
                              alt={isCopiedShare ? "Copied" : "Copy"}
                              className={styles.copyIcon}
                            />
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              )}
            </div>
          )} */}
        </div>

        {/* Profile button - MOVED OUTSIDE rightSection */}
        {/* Profile button container - separate from rightSection */}
        <div
          className={styles.profileButtonContainer}
          style={{
            borderTop:
              showTopBorder && isToolbarExpanded
                ? "1px solid var(--color-border)"
                : "none",
          }}
        >
          <button
            className={`${styles.profileButton} ${
              showProfileDropdown ? styles.profileButtonActive : ""
            }`}
            onClick={(e) => {
              setHoveredTooltip(null);

              // If toolbar is collapsed, expand it AND open dropdown
              if (!isToolbarExpanded) {
                const button = e.currentTarget;
                onToolbarExpandChange?.(true);
                setTimeout(() => {
                  const rect = button.getBoundingClientRect();
                  setProfileButtonRect(rect);
                  setShowProfileDropdown(true);
                }, 0);
              } else {
                // If already expanded, just toggle dropdown
                setProfileButtonRect(e.currentTarget.getBoundingClientRect());
                setShowProfileDropdown(!showProfileDropdown);
              }
            }}
            onMouseEnter={(e) => {
              if (!isToolbarExpanded) {
                // setHoveredTooltip({
                //   text: displayName,
                //   rect: e.currentTarget.getBoundingClientRect(),
                //   type: "side",
                // });
              }
            }}
            onMouseLeave={() => {
              setHoveredTooltip(null);
            }}
          >
            <div className={styles.profileCircle}>
              {userAvatar.type === "image" ? (
                <img
                  src={userAvatar.value}
                  alt="Profile"
                  referrerPolicy="no-referrer"
                  className={styles.profileImage}
                />
              ) : (
                <span className={styles.profileInitials}>
                  {userAvatar.value}
                </span>
              )}
            </div>
            {isToolbarExpanded && (
              <div className={styles.profileInfo}>
                <span className={styles.profileLabel}>{displayName}</span>
                <span className={styles.subscriptionTier}>
                  {getSubscriptionTier()}
                </span>
              </div>
            )}
          </button>
        </div>
      </div>

      {/* Feedback Modal - Render as portal to escape toolbar z-index */}
      {showFeedbackModal &&
        createPortal(
          <div
            className={styles.modalOverlay}
            onClick={handleCloseFeedbackModal}
          >
            <div
              className={styles.feedbackModalContent}
              onClick={(e) => e.stopPropagation()}
            >
              <div className={styles.feedbackModalHeader}>
                <h3 className={styles.feedbackModalTitle}>Give feedback</h3>
                <button
                  className={styles.feedbackModalCloseButton}
                  onClick={handleCloseFeedbackModal}
                  aria-label="Close"
                >
                  <img
                    src={closeIcon}
                    alt="Close"
                    className={styles.feedbackModalCloseIcon}
                  />
                </button>
              </div>

              <div className={styles.feedbackModalBody}>
                {feedbackSubmitted ? (
                  <>
                    <div className={styles.feedbackSuccessTitle}>
                      Feedback sent, thank you!
                    </div>
                    <p className={styles.feedbackSuccessText}>
                      We really appreciate you taking the time to share your
                      thoughts. Your feedback goes straight to the team and
                      helps shape what we build next.
                    </p>
                    <button
                      className={styles.feedbackSubmitAnotherButton}
                      onClick={() => {
                        setFeedbackSubmitted(false);
                        setFeedbackText("");
                      }}
                    >
                      Submit another piece of feedback
                    </button>
                  </>
                ) : (
                  <>
                    <div className={styles.feedbackPrompt}>
                      Share what's working well, what's frustrating, or what
                      you'd love to see next. Bugs, ideas, or quick thoughts -
                      all feedback helps shape the product.
                    </div>
                    <textarea
                      className={styles.feedbackTextarea}
                      placeholder={`Type freely - short notes or detailed thoughts are both welcome.`}
                      value={feedbackText}
                      onChange={(e) => setFeedbackText(e.target.value)}
                    />
                    <button
                      className={styles.feedbackSubmitButton}
                      onClick={handleSubmitFeedback}
                      disabled={!feedbackText.trim()}
                    >
                      Submit feedback
                    </button>
                    <div className={styles.feedbackDisclaimer}>
                      We review every submission. Your feedback is private,
                      never shared with third parties, and used only to improve
                      Noah.
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>,
          document.body,
        )}

      {/* Settings Modal */}
      {showSettingsModal &&
        createPortal(
          <div
            className={styles.modalOverlay}
            onClick={handleCloseSettingsModal}
          >
            <div
              className={styles.settingsModalContent}
              onClick={(e) => e.stopPropagation()}
            >
              <input
                ref={fileInputRef}
                type="file"
                accept="image/*"
                style={{ display: "none" }}
                onChange={handleFileChange}
              />

              <div className={styles.settingsModalHeader}>
                <h3 className={styles.settingsModalTitle}>
                  {showDeleteModal ? "Are you sure?" : "Settings"}
                </h3>
                <button
                  className={styles.feedbackModalCloseButton}
                  onClick={handleCloseSettingsModal}
                  aria-label="Close"
                >
                  <img
                    src={closeIcon}
                    alt="Close"
                    className={styles.feedbackModalCloseIcon}
                  />
                </button>
              </div>

              <div className={styles.settingsModalBody}>
                {showDeleteModal ? (
                  <>
                    <div className={styles.deleteConfirmContent}>
                      <p className={styles.deleteConfirmText}>
                        This will permanently delete your account and all
                        associated data. You'll immediately lose access, and
                        this action cannot be undone.
                      </p>
                    </div>
                    <button
                      className={styles.deleteConfirmDeleteButton}
                      onClick={handleDeleteConfirm}
                      disabled={isDeleting}
                    >
                      {isDeleting
                        ? "Deleting your account..."
                        : "Yes, delete my account"}
                    </button>
                  </>
                ) : (
                  <>
                    <div className={styles.settingsPhotoSection}>
                      <div className={styles.settingsProfileCircle}>
                        {isSavingName && (
                          <div className={styles.photoUploadLoading}>
                            <img
                              src={billingLoad}
                              alt="Uploading..."
                              className={styles.photoUploadSpinner}
                            />
                          </div>
                        )}
                        {(() => {
                          const avatar = getSettingsUserAvatar();
                          if (avatar.type === "image") {
                            return (
                              <img
                                src={avatar.value}
                                alt="Profile"
                                referrerPolicy="no-referrer"
                                className={styles.settingsProfileImage}
                              />
                            );
                          } else {
                            return (
                              <span className={styles.settingsProfileInitials}>
                                {avatar.value}
                              </span>
                            );
                          }
                        })()}
                      </div>
                      <button
                        className={styles.changePhotoButton}
                        onClick={handleUploadClick}
                        disabled={isSavingName}
                      >
                        {isSavingName ? "Uploading..." : "Change photo"}
                      </button>
                    </div>

                    <div className={styles.settingsSection}>
                      <div className={styles.settingsSectionLabel}>Name</div>
                      <input
                        type="text"
                        value={editedName}
                        onChange={handleNameChange}
                        className={styles.settingsLargeInput}
                        placeholder="Enter your full name"
                      />
                    </div>

                    {!isEmailAuth && (
                      <>
                        <div className={styles.settingsSection}>
                          <div className={styles.settingsSectionLabel}>
                            Email
                          </div>
                          <div
                            className={styles.settingsEmailDisplayTransparent}
                          >
                            <div className={styles.settingsEmailIcon}>
                              {(() => {
                                const authIcon = getAuthProviderIcon();
                                if (authIcon.type === "component") {
                                  return authIcon.icon;
                                }
                                return null;
                              })()}
                            </div>
                            <span className={styles.settingsEmailText}>
                              {user?.email || "No email set"}
                            </span>
                          </div>
                        </div>
                      </>
                    )}

                    {isEmailAuth && !isEditingEmail && !pendingEmail && (
                      <>
                        <div className={styles.settingsSection}>
                          <div className={styles.settingsSectionLabel}>
                            Email
                          </div>
                          <div className={styles.settingsDisplayBox}>
                            {user?.email || "No email set"}
                          </div>
                          <button
                            className={styles.settingsChangeButton}
                            onClick={handleChangeEmailClick}
                          >
                            Change email
                          </button>
                        </div>
                      </>
                    )}

                    {isEmailAuth && isEditingEmail && (
                      <div className={styles.settingsSection}>
                        <div className={styles.settingsSectionNoBorder}>
                          <div className={styles.settingsSectionLabel}>
                            Current email
                          </div>
                          <div className={styles.settingsDisplayBox}>
                            {user?.email || "No email set"}
                          </div>
                        </div>

                        <div className={styles.settingsSectionNoBorder}>
                          <div className={styles.settingsSectionLabel}>
                            New email
                          </div>
                          <input
                            type="email"
                            value={editedEmail}
                            onChange={(e) => {
                              setEditedEmail(e.target.value);
                              setSettingsError(null);
                            }}
                            className={styles.settingsLargeInput}
                            placeholder="name@example.com"
                            autoComplete="off"
                            autoFocus
                          />
                        </div>
                        <div className={styles.settingsSectionNoBorder}>
                          <div className={styles.settingsSectionLabel}>
                            Password
                          </div>
                          <input
                            type="password"
                            value={emailConfirmPassword}
                            onChange={(e) => {
                              setEmailConfirmPassword(e.target.value);
                              setSettingsError(null);
                            }}
                            className={styles.settingsLargeInput}
                            placeholder="Confirm with your password"
                            autoComplete="new-password"
                          />
                        </div>

                        <button
                          className={styles.settingsSaveChangesButton}
                          onClick={handleEmailSaveClick}
                          disabled={
                            !isValidEmail(editedEmail) ||
                            !emailConfirmPassword ||
                            isSavingEmail
                          }
                        >
                          {isSavingEmail ? "Saving..." : "Save changes"}
                        </button>
                      </div>
                    )}

                    {isEmailAuth && pendingEmail && (
                      <>
                        <div className={styles.settingsSection}>
                          <div className={styles.settingsSectionLabel}>
                            Email
                          </div>
                          <div className={styles.settingsSuccessText}>
                            We've {isResendingEmail ? "re-" : ""}sent a
                            verification link to your new email. Click the link
                            in that email to confirm your new address.
                          </div>
                          <button
                            className={styles.settingsChangeButton}
                            onClick={handleResendVerificationEmail}
                            disabled={isResendingEmail}
                          >
                            {isResendingEmail ? "Resending..." : "Resend link"}
                          </button>
                        </div>
                      </>
                    )}

                    {isEmailAuth && !isEditingPassword && (
                      <>
                        <div className={styles.settingsSection}>
                          <div className={styles.settingsSectionLabel}>
                            Password
                          </div>
                          <div className={styles.settingsDisplayBox}>
                            ••••••••
                          </div>
                          <button
                            className={styles.settingsChangeButton}
                            onClick={handleChangePasswordClick}
                          >
                            Change password
                          </button>
                        </div>
                      </>
                    )}

                    {isEmailAuth && isEditingPassword && (
                      <div className={styles.settingsSection}>
                        <div className={styles.settingsSectionNoBorder}>
                          <div className={styles.settingsSectionLabel}>
                            Current password
                          </div>
                          <div className={styles.settingsPasswordContainer}>
                            <input
                              type={showCurrentPassword ? "text" : "password"}
                              value={currentPassword}
                              onChange={(e) => {
                                setCurrentPassword(e.target.value);
                                setSettingsError(null);
                              }}
                              className={styles.settingsLargeInput}
                              placeholder="••••••••"
                              autoComplete="new-password"
                              autoFocus
                            />
                            <button
                              type="button"
                              onClick={() =>
                                setShowCurrentPassword(!showCurrentPassword)
                              }
                              className={styles.settingsPasswordToggle}
                            >
                              <img
                                src={
                                  showCurrentPassword
                                    ? visibleIcon
                                    : notVisibleIcon
                                }
                                alt={
                                  showCurrentPassword
                                    ? "Hide password"
                                    : "Show password"
                                }
                                className={styles.settingsEyeIcon}
                              />
                            </button>
                          </div>
                        </div>

                        <div className={styles.settingsSectionNoBorder}>
                          <div className={styles.settingsSectionLabel}>
                            New password
                          </div>
                          <div className={styles.settingsPasswordContainer}>
                            <input
                              type={showNewPassword ? "text" : "password"}
                              value={newPassword}
                              onChange={(e) => {
                                setNewPassword(e.target.value);
                                setSettingsError(null);
                              }}
                              className={styles.settingsLargeInput}
                              placeholder="8+ characters"
                              autoComplete="new-password"
                            />
                            {newPassword.length > 0 && (
                              <img
                                src={
                                  newPassword.length >= 8
                                    ? checkIcon
                                    : warningIcon
                                }
                                alt={
                                  newPassword.length >= 8
                                    ? "Valid password"
                                    : "Invalid password"
                                }
                                className={styles.settingsPasswordStatusIcon}
                              />
                            )}
                            <button
                              type="button"
                              onClick={() =>
                                setShowNewPassword(!showNewPassword)
                              }
                              className={styles.settingsPasswordToggle}
                            >
                              <img
                                src={
                                  showNewPassword ? visibleIcon : notVisibleIcon
                                }
                                alt={
                                  showNewPassword
                                    ? "Hide password"
                                    : "Show password"
                                }
                                className={styles.settingsEyeIcon}
                              />
                            </button>
                          </div>
                        </div>
                        <div className={styles.settingsSectionNoBorder}>
                          <div className={styles.settingsSectionLabel}>
                            Confirm new password
                          </div>
                          <div className={styles.settingsPasswordContainer}>
                            <input
                              type={showConfirmPassword ? "text" : "password"}
                              value={confirmNewPassword}
                              onChange={(e) => {
                                setConfirmNewPassword(e.target.value);
                                setSettingsError(null);
                              }}
                              className={styles.settingsLargeInput}
                              placeholder="8+ characters"
                              autoComplete="new-password"
                            />
                            {confirmNewPassword.length > 0 && (
                              <img
                                src={
                                  confirmNewPassword.length >= 8 &&
                                  confirmNewPassword === newPassword
                                    ? checkIcon
                                    : warningIcon
                                }
                                alt={
                                  confirmNewPassword.length >= 8 &&
                                  confirmNewPassword === newPassword
                                    ? "Passwords match"
                                    : "Passwords don't match"
                                }
                                className={styles.settingsPasswordStatusIcon}
                              />
                            )}
                            <button
                              type="button"
                              onClick={() =>
                                setShowConfirmPassword(!showConfirmPassword)
                              }
                              className={styles.settingsPasswordToggle}
                            >
                              <img
                                src={
                                  showConfirmPassword
                                    ? visibleIcon
                                    : notVisibleIcon
                                }
                                alt={
                                  showConfirmPassword
                                    ? "Hide password"
                                    : "Show password"
                                }
                                className={styles.settingsEyeIcon}
                              />
                            </button>
                          </div>
                        </div>
                        <button
                          className={styles.settingsSaveChangesButton}
                          onClick={handlePasswordSaveClick}
                          disabled={
                            !currentPassword ||
                            newPassword.length < 8 ||
                            confirmNewPassword !== newPassword ||
                            isSavingPassword
                          }
                        >
                          {isSavingPassword ? "Saving..." : "Save changes"}
                        </button>
                      </div>
                    )}

                    <div className={styles.settingsDeleteSection}>
                      <div className={styles.settingsDeleteContent}>
                        <div className={styles.settingsDeleteLabel}>
                          Deleting your Noah account will immediately revoke
                          access to all projects and permanently delete your
                          data. This action can't be undone.
                        </div>
                      </div>
                    </div>

                    {/* ✅ NEW: Check for active subscription before allowing delete */}
                    {userProfile?.subscriptionStatus === "active" &&
                    userProfile?.subscriptionTier !== "free" &&
                    userProfile?.subscriptionTier !== undefined ? (
                      <div className={styles.activeSubscriptionWarning}>
                        <div className={styles.warningHeader}>
                          <img
                            src={warningIcon}
                            alt="Warning"
                            style={{ width: "0.875rem", height: "0.875rem" }}
                          />
                          <span>Active Subscription Detected</span>
                        </div>
                        <p>
                          You are currently subscribed to the{" "}
                          <strong>{userProfile.subscriptionTier}</strong> plan.
                          Please cancel your subscription before deleting your
                          account to avoid being charged.
                        </p>
                        <button
                          className={styles.manageSubscriptionButton}
                          onClick={handleBillingClick}
                        >
                          Manage Subscription
                        </button>
                      </div>
                    ) : (
                      <button
                        className={styles.settingsDeleteAccountButton}
                        onClick={handleDeleteAccount}
                      >
                        Permanently delete account
                      </button>
                    )}
                  </>
                )}
              </div>
            </div>
          </div>,
          document.body,
        )}

      {/* Delete Confirmation Modal for Models */}
      {showDeleteModal &&
        !showSettingsModal &&
        createPortal(
          <div className={styles.modalOverlay} onClick={handleCloseDeleteModal}>
            <div
              className={styles.deleteModalContent}
              onClick={(e) => e.stopPropagation()}
            >
              <div className={styles.deleteModalHeader}>
                <h3 className={styles.deleteModalTitle}>
                  Delete model permanently?
                </h3>
                <button
                  className={styles.feedbackModalCloseButton}
                  onClick={handleCloseDeleteModal}
                  aria-label="Close"
                  disabled={isDeleting}
                >
                  <img
                    src={closeIcon}
                    alt="Close"
                    className={styles.feedbackModalCloseIcon}
                  />
                </button>
              </div>

              <div className={styles.feedbackModalBody}>
                <div className={styles.deletePrompt}>
                  You're about to delete:
                </div>

                <div className={styles.deleteModelName}>
                  <img
                    src={parametricIcon}
                    alt="Model"
                    className={styles.deleteModelIcon}
                  />
                  <span className={styles.deleteModelText}>
                    {deletingProjectName}
                  </span>
                </div>

                <div className={styles.deleteWarningSection}>
                  <div className={styles.deleteWarningTitle}>
                    This action will permanently remove the model and all
                    associated data. This cannot be undone.
                  </div>
                </div>

                <button
                  className={styles.deleteSubmitButton}
                  onClick={handleModelDeleteConfirm}
                  disabled={isDeleting}
                >
                  {isDeleting ? "Deleting..." : "Delete permanently"}
                </button>

                <div className={styles.feedbackDisclaimer}>
                  Deleting this model will also permanently remove access for
                  all users you've previously shared it with.
                </div>
              </div>
            </div>
          </div>,
          document.body,
        )}
      {/* Profile Dropdown Portal */}
      {showProfileDropdown &&
        profileButtonRect &&
        createPortal(
          <div
            ref={profileDropdownRef}
            className={styles.profileDropdownPortal}
            style={{
              position: "fixed",
              left: `${profileButtonRect.left}px`,
              bottom: `${window.innerHeight - profileButtonRect.top}px`, // CHANGED: Remove the +4 offset
              zIndex: 100000,
              width: isToolbarExpanded ? "280px" : "280px", // CHANGED: Fixed width instead of dynamic
              minWidth: "auto",
              maxWidth: "none",
            }}
          >
            <div className={styles.profileDropdown}>
              {/* Auth Provider Info */}
              <div
                className={
                  authMethod === "google"
                    ? styles.authInfoTransparent
                    : styles.authInfo
                }
                // 2. NEW: Force the inner flex container to be as wide as the text
                // This prevents 'overflow: hidden' from collapsing the width
                style={{
                  width: isToolbarExpanded ? "auto" : "max-content",
                  maxWidth: "100%", // Ensure it respects the parent's clamp
                }}
              >
                {(() => {
                  const authIcon = getAuthProviderIcon();
                  if (authIcon.type === "component") {
                    return (
                      <div className={styles.authIcon}>{authIcon.icon}</div>
                    );
                  } else {
                    return (
                      <div className={styles.authIcon}>
                        <img
                          src={authIcon.icon as string}
                          alt="Auth provider"
                        />
                      </div>
                    );
                  }
                })()}
                <span
                  className={
                    authMethod === "google"
                      ? styles.authEmailTransparent
                      : styles.authEmail
                  }
                  style={{
                    // If collapsed, 'unset' flex so the text width pushes the container open.
                    // If expanded, keep '1' so it fills the 264px space.
                    flex: isToolbarExpanded ? 1 : "unset",
                  }}
                >
                  {user?.email || "user@example.com"}
                </span>
              </div>

              {/* Credits Section */}
              <div className={styles.creditsSection}>
                <div
                  className={styles.creditsButton}
                  onClick={(e) => {
                    e.stopPropagation();
                    setShowProfileDropdown(false); // add this line
                    setIsCreditsModalOpen(true);
                    onShowCreditsModal();
                  }}
                >
                  <div className={styles.creditsLeft}>
                    <img
                      src={creditsIcon}
                      alt="Generations"
                      className={styles.creditsIconImage}
                    />
                    <span className={styles.creditsText}>Generations</span>
                  </div>
                  <div className={styles.creditsRight}>
                    <span className={styles.creditsCount}>
                      {getCreditDisplay()}
                    </span>
                    <img
                      src={chevronIcon}
                      alt="More"
                      className={styles.creditsChevronIcon}
                    />
                  </div>
                </div>
              </div>

              <div className={styles.dropdownSeparatorWithGap}></div>

              {/* Theme */}
              <div className={styles.themeOption}>
                <img
                  src={themeIcon}
                  alt="Theme"
                  className={styles.dropdownIcon}
                />
                <span className={styles.dropdownText}>Theme</span>
                <div className={styles.themeIcons}>
                  <button
                    className={styles.themeIconButton}
                    onClick={(e) => {
                      e.stopPropagation();
                      handleThemeToggle("light", e);
                    }}
                  >
                    <img
                      src={getLightModeIcon()}
                      alt="Light mode"
                      className={styles.themeIconImage}
                    />
                  </button>
                  <button
                    className={styles.themeIconButton}
                    onClick={(e) => {
                      e.stopPropagation();
                      handleThemeToggle("dark", e);
                    }}
                  >
                    <img
                      src={getDarkModeIcon()}
                      alt="Dark mode"
                      className={styles.themeIconImage}
                    />
                  </button>
                  <button
                    className={styles.themeIconButton}
                    onClick={(e) => {
                      e.stopPropagation();
                      handleThemeToggle("system", e);
                    }}
                  >
                    <img
                      src={getSystemModeIcon()}
                      alt="System mode"
                      className={styles.themeIconImage}
                    />
                  </button>
                </div>
              </div>

              {/* Billing */}
              {hasStripeCustomerId && (
                <div
                  className={styles.dropdownOption}
                  onClick={handleBillingClick}
                >
                  <img
                    src={billingIcon}
                    alt="Billing"
                    className={styles.dropdownIcon}
                  />
                  <span className={styles.dropdownText}>Billing</span>
                  <img
                    src={isBillingLoading ? billingLoad : sendIcon}
                    alt={isBillingLoading ? "Loading" : "External link"}
                    className={`${styles.sendIcon} ${
                      isBillingLoading ? styles.spinning : ""
                    }`}
                  />
                </div>
              )}

              {/* Settings */}
              <div
                className={styles.dropdownOption}
                onClick={(e) => {
                  e.stopPropagation();
                  handleOpenSettings();
                }}
              >
                <img
                  src={accountIcon}
                  alt="Settings"
                  className={styles.dropdownIcon}
                />
                <span className={styles.dropdownText}>Settings</span>
              </div>

              <div className={styles.dropdownSeparator}></div>

              {/* Join Community */}
              <div
                className={styles.dropdownOption}
                onClick={handleJoinCommunity}
              >
                <img
                  src={discordIcon}
                  alt="Join community"
                  className={styles.dropdownIcon}
                />
                <span className={styles.dropdownText}>Join community</span>
                <img
                  src={sendIcon}
                  alt="External link"
                  className={styles.sendIcon}
                />
              </div>

              {/* Send Feedback */}
              <div
                className={styles.dropdownOption}
                onClick={(e) => {
                  e.stopPropagation();
                  setIsFeedbackModalOpen(true);
                  handleSendFeedback();
                }}
              >
                <img
                  src={feedbackIcon}
                  alt="Give feedback"
                  className={styles.dropdownIcon}
                />
                <span className={styles.dropdownText}>Give feedback</span>
              </div>

              <div className={styles.dropdownSeparator}></div>

              {/* Terms */}
              <div
                className={styles.dropdownOption}
                onClick={(e) => {
                  e.stopPropagation();
                  window.open("/terms", "_blank");
                  setShowProfileDropdown(false);
                }}
              >
                <img
                  src={termsIcon}
                  alt="Terms of service"
                  className={styles.dropdownIcon}
                />
                <span className={styles.dropdownText}>Terms of service</span>
                <img
                  src={sendIcon}
                  alt="External link"
                  className={styles.sendIcon}
                />
              </div>

              {/* Privacy */}
              <div
                className={styles.dropdownOption}
                onClick={(e) => {
                  e.stopPropagation();
                  window.open("/privacy", "_blank");
                  setShowProfileDropdown(false);
                }}
              >
                <img
                  src={policyIcon}
                  alt="Privacy policy"
                  className={styles.dropdownIcon}
                />
                <span className={styles.dropdownText}>Privacy policy</span>
                <img
                  src={sendIcon}
                  alt="External link"
                  className={styles.sendIcon}
                />
              </div>

              <div className={styles.dropdownSeparator}></div>

              {/* Logout */}
              <div
                className={styles.dropdownOption}
                onClick={(e) => {
                  e.stopPropagation();
                  handleLogout();
                }}
              >
                <img
                  src={logoutIcon}
                  alt="Log out"
                  className={styles.dropdownIcon}
                />
                <span className={styles.dropdownText}>Logout</span>
              </div>
            </div>
          </div>,
          document.body,
        )}
      {/* Tooltip Portal - renders outside toolbar to avoid z-index issues */}
      {hoveredTooltip &&
        createPortal(
          <div
            className={styles.tooltipPortal}
            style={{
              position: "fixed",
              top:
                hoveredTooltip.type === "side"
                  ? `${hoveredTooltip.rect.top + hoveredTooltip.rect.height / 2}px`
                  : `${hoveredTooltip.rect.bottom + 8}px`,
              left:
                hoveredTooltip.type === "side"
                  ? `${hoveredTooltip.rect.right + 16}px`
                  : `${hoveredTooltip.rect.left + hoveredTooltip.rect.width / 2}px`,
              transform:
                hoveredTooltip.type === "side"
                  ? "translateY(-50%)"
                  : "translateX(-50%)",
            }}
          >
            {hoveredTooltip.text}{" "}
            {hoveredTooltip.command && (
              <span className={styles.tooltipCommand}>
                ({hoveredTooltip.command})
              </span>
            )}
          </div>,
          document.body,
        )}
    </>
  );
};

export default TopToolbar;
